<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<h1 v-if="$vuetify.breakpoint.smAndUp" class="band-color-blue interview-title">
					Day 3 - Missouri
				</h1>
				<h1 v-else class="band-color-blue interview-title-sm">
					Day 3 - Missouri
				</h1>
			</v-col>
			<v-col>
				<p class="band-color-blue word-salad">
					(Hawaii 5-O, Mr. Pessimist, The Psychological Community, Papayas, Welcome To The Club Kid, Obama Starts To Falter, Golden Spike, Eric Holder, Terrifying Israel, At Sixes And Sevens, Missouri Settlers, Royals Flush, Wintertime in Hollywood, Rockstars To The Rescue, Pin The Tail On The Donkey, Alternate Universe, Zombie Flicks, The Great Carlos Ghosn, North Shore, Zooropa, St. Louis Sorrow, Quotes, Leaving You Nothing, Poles Apart, A Painful Departure, American in Decay; the Old, Old Story, The Grapes Of Ambition, Europe Is Dying, Mother Jones, Tinseltown In The Rain, Exporting Nonsense, As The Crow Flies, Blakisms, It’s Debatable, Obama: Cutting The Eruv, Show Me, The Apprentice, Mistral Wind, The Casting Library, Arab Snub, Thrown In Your Lap, Stop Dragging My Heart Around, Election 2016, In A New York Minute, Hillary Leaking, Rip Van Winkle, No Nukes, Getting Screwed Over, Every Picture Tells A Story, Hillary Melts, Appalachian Folks, Donner Party, Wheel Of Torture, Academic Groupies, Your Cheating Heart, Obama: Winning the War On Dougs, Snuffing Out The Theorem, Inferring Yeats, Mr. Invisible, Her Strut, Teeth Marks Of Time, Art For Art's Sake, Celluloid Heroes, Steinbeck and more…… See Timeline for Synopsis of Events)
				</p>
			</v-col>
			<v-col cols="12" class="main-text text-border">
				<p class="h-l">
				H.L. I was listening to the tape last night and going over the notes and a quote came to mind, I thought it was appropriate:
				<span class="break"></span>
				<span class="italic">
				Everyone thinks of changing the world, but no one thinks of changing himself. <span class="break"></span>Leo Tolstoy.</span>
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s good, and appropriate, but it’s Lev.
				</p>
				<p class="h-l">
				H.L. Correction then: Lev Tolstoy.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You really want to do this, start out the morning by laying quotes on me? I have spent my life in the greatest books of world literature. You’re very brave.
				<span class="break"></span>
				How about:
				<span class="break"></span>
				<span class="italic">
				The monster of a land, this mightiest of nations, this spawn of the future, turns out to be the macrocosm of microcosm me. <span class="break"></span>John Steinbeck.
				</span>
				</p>
				<p class="h-l">
				H.L. That’s good; I have never heard that one before. Where is it from?
				</p>
				<p>
				<span class="douglas">Douglas:</span> <span class="italic">Travels with Charley.</span>
				</p>
				<p class="h-l">
				H.L. That’s a great book, where he takes his poodle with him on an exodus around America.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, obscure quote too. You won’t find that one on the internet, at least not yet. I stumped one of my college English professors with those lines. She made me bring her a copy of the book, and show her the quote.
				</p>
				<p class="h-l">
				H.L. All right, last one:
				<span class="break"></span>
				<span class="italic">When I let go of what I am, I become what I might be:
				<span class="break"></span>
				Lao Tzu</span>
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s good, appropriate and very West Coast. But it’s over circulated; any high school student can look that one up.
				<span class="break"></span>
				I will take you out into deep water and drown you now!
				</p>
				<p class="h-l">
				H.L. Oh really, let’s see.
				</p>
				<p>
				<span class="douglas">Douglas:</span>
				<span class="italic">
				Tried hard to find a wise man, but all I could find was a fool. There’s history books full of lies and a PhD for a soul.
				<span class="break"></span>
				And all of these heroes we struggle to find are really just freaks in a circus, they take off their costumes and rewind their minds, but in the end they desert us.</span>
				</p>
				<p class="h-l">
				H.L. Okay you win. I surrender; I can see I am overmatched. But who is it?
				</p>
				<p>
				<span class="douglas">Douglas:</span> It’s actually not from a book, but a song. He is a talented jazz musician: Michael Franks.
				</p>
				<p class="h-l">
				H.L. I know of the artist, he is good. But that is cheating; I thought we were focusing on books, and authors. Not on song lyrics.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Hey, who plays fair? Maybe I have learned a thing or two from the wealthy, or more accurately, from the government.
				<span class="break"></span>
				But Franks has his masters in literature, so it’s only half cheating. Plus, in my interpretation at least, there is an analogy to Yeats in there; <span class="italic">The Circus Animals Desertion.</span>
				</p>
				<p class="h-l">
				H.L. I noticed that… I think. A great poem?
				</p>
				<p>
				<span class="douglas">Douglas:</span> One of Yeats best. ‘The foul rag and bone shop of the heart’. Now that line is appropriate to this interview.
				<span class="break"></span>
				Are we going to stop this phallic measuring contest? We need to get to work.
				</p>
				<p class="h-l">
				H.L. Yes, but I can’t get those lines out of my head. ‘Tried hard to find a wise man, but all I could find was a fool’.
				</p>
				<p>
				<span class="douglas">Douglas:</span> They are very powerful.
				<span class="break"></span>
				I have actually lived those lines or experienced those; I have earned them.
				</p>
				<p class="h-l">
				H.L. What do you mean?
				</p>
				<p>
				<span class="douglas">Douglas:</span> We don’t have time, we are already running behind.
				</p>
				<p class="h-l">
				H.L. Then you shouldn’t have said anything, obviously you want to share it. So go ahead.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, well it still bothers me; actually I used that quote just so we could talk about this. Seeing as you are cheap therapy. Essentially what happened was that the psychologist who helped me get better, well enough to finally compose the final edition of The Theorem, screwed me over.
				</p>
				<p class="h-l">
				H.L. How?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well he ultimately changed his psychological approach and tried to mimic my book. It wasn’t plagiarism, more like an angry reaction.
				</p>
				<p class="h-l">
				H.L. Well you have been through the ringer. Who is he?
				</p>
				<p>
				<span class="douglas">Douglas:</span> More like, who was he? He is dead now, gone to a better place. He lived a good long life and someday, one day, he will be remembered as a great psychologist years ahead of his time. He was very famous. I just prefer not to walk on his grave though by naming him. Insiders however, especially those in the psychological community likely know the story.
				</p>
				<p class="h-l">
				H.L. Sounds like he did ‘desert’ you. Can you be a little more specific?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, like I said it still bothers me. Well, I had already made the discovery when I went to his institute in late 2000. I didn’t tell anyone there about The Theorem at the time. But his focus was on early childhood issues; he developed a technique that could rip the pain right out of you. It is very effective, but I would only recommend it for extreme cases.
				<span class="break"></span>
				Anyways, right before The Theorem was to be published, my publisher asked me to seek endorsements. This was in 2005. So I sent this psychologist an email, and in return he requested a copy. I sent him a copy. I was nervous, in a way he was my mentor.
				</p>
				<p class="h-l">
				H.L. Sure.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I was very generous in my words to him; I said history would remember him kindly and so forth. I really believed, and still do, in his therapeutic approach.
				<span class="break"></span>
				So I didn’t hear anything. He told me later he never endorses anything.
				</p>
				<p class="h-l">
				H.L. Strange; well then why did he agree to accept a copy if he had no plans to endorse?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well that was my question. But I just let it go.
				<span class="break"></span>
				Then a few years later, like I said, he came out with a book on the womb. It was a very predictable approach; all outdated parochial thinking. The book was a flop, but still I was hurt.
				</p>
				<p class="h-l">
				H.L. You felt betrayed.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure. But I almost forgot to mention. Before he published his book, he had a friend of his, another famous psychologist, write this mixed review of The Theorem. Essentially saying it was a great discovery but that I should turn it all over to them; being him and the other psychologist I assume. In his review he basically said then I could be in their club, if I followed their rules.
				</p>
				<p class="h-l">
				H.L. That’s pretty brutal.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yeah, well then I sent him back a note saying, “I don’t need to be in your club, as I just bought the clubhouse.”
				</p>
				<p class="h-l">
				H.L. That’s a good one. It’s too bad when people turn on you like that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It really is. Because while some of my work contradicted his beliefs, other parts only reinforced it. My focus was never on therapy or getting people better. There was no competition.
				</p>
				<p class="h-l">
				H.L. But he didn’t see it that way?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, by that time he was getting pretty old. He had been beat up by the psychological community for years. They had pilfered much of his work, his discovery, and repackaged it. So I guess he figured it was my turn.
				</p>
				<p class="h-l">
				H.L. Welcome to the club kid!
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly. Good line.
				</p>
				<p class="h-l">
				H.L. Actually I am glad you brought this all up, after all this is an interview about a major psychological discovery, behind this cover-up.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Thank you. Yes, it is. It is essential to clarify to the readers that this book is not about abortion. It has nothing to do with abortion. There is not a single word about abortion in there. So if the reader is coming to look for that they will be disappointed.
				<span class="break"></span>
				This is raw and refined psychological theory; a neurodevelopmental model that defines the origins of our behaviors and disorders.
				<span class="break"></span>
				Thanks for that. Thank you for reminding me to mention it.
				</p>
				<p class="h-l">
				H.L. No problem. So do you feel then disappointed in the psychology community in the whole or was that just an isolated incident?
				</p>
				<p>
				<span class="douglas">Douglas:</span> That wasn’t an isolated incident.
				</p>
				<p class="h-l">
				H.L. No?
				</p>
				<p>
				<span class="douglas">Douglas:</span> It got worse.
				</p>
				<p class="h-l">
				H.L. I find that hard to believe.
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, it definitely did. You see, I lived in Hawaii for a time during those eight years and I was working on some personal issues relating to my divorce etc. So I looked up a psychologist, and made an appointment.
				</p>
				<p class="h-l">
					H.L. Okay.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well everything was going fine on the first visit. I did not tell him about The Theorem, as I never really tell anyone until I know them better, as this prevents them from freaking out and running away. But he asked my occupation, so I said writer. He wanted to know about what I had written and I told him I would rather not talk about it, as it was not relevant to the purpose of my visit.
				</p>
				<p class="h-l">
				H.L Makes sense.
				</p>
				<p>
				<span class="douglas">Douglas:</span> The second meeting was different. I could tell something was wrong.
				<span class="break"></span>
				He’s pacing back and forth to the copy machine. Finally, after awhile he sits down and throws these stapled papers at me; onto my lap. It was a photocopied review of my book by some crackpot psychologist, who has since removed it, that he found on the internet. It wasn’t a flattering review either.
				<span class="break"></span>
				I was shocked, as this had nothing to do with the purpose of our session. Then he wanted me to read it to him. I just threw it back at him and walked out. Later he called and apologized and said he was trying to gauge my response. But when I wasn’t buying his story, he finally admitted that he had written a book and was frustrated that he couldn’t get it published.
				</p>
				<p class="h-l">
				H.L. Well at least you got him to be honest with himself, probably the first time in his life.
				<span class="break"></span>
				That is a really bizarre encounter though. Did it stop you from going to therapy?
				</p>
				<p>
				<span class="douglas">Douglas:</span> With that nut job it did, but I went to a few others after that. Although from then on I would give a false name, pay cash and tell them I was a mystery writer or some other genre, and was not published.
				</p>
				<p class="h-l">
				H.L. That’s tragic, kind of sad in a way, but I can see the problems you may run into.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Certainly they are problems that I could have never imagined. This discovery has caused so many awkward and unwelcome repercussions that I never anticipated; case in point, the content of this interview.
				</p>
				<p class="h-l">
				H.L. Hawaii is very nice, did you live there long?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, maybe 5 or 6 months. It wasn’t a pleasure trip at all. My parents were living on Maui at the time, and I could see my father failing; right after I moved away he was formally diagnosed with ALS. So I wanted to be close to him, but not too close, therefore I moved to Oahu.
				</p>
				<p class="h-l">
				H.L. Did it give you time to work on your issues with your dad?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, it did. But it’s expensive to live in Hawaii, so I worked two jobs; as a laborer loading papayas onto airplanes, and a shuttle bus driver for the tourists. I just stayed long enough to save money and head to Asia where things were less expensive. I live on very little income, like I said.
				</p>
				<p class="h-l">
				H.L. No more horror stories about envious psychologists to share?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, no more. I still didn’t really answer your question though, about The Theorem and the reception in general from the psychological community. Do we have space?
				</p>
				<p class="h-l">
				H.L. Go ahead.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, I think this is significant. My feelings have changed towards them over the years. Looking back, I really see them as victims of the liberal or Democratic Elite as well. If anyone said anything positive about The Theorem to one of their colleagues, they very likely would have been immediately dismissed.
				<span class="break"></span>
				Now I do not have any proof of this in the psychological community, but in the field of neuroscience, I was told by a victim about their experience.
				<span class="break"></span>
				Actually more than one professor, but the second incident was through a third party.
				</p>
				<p class="h-l">
				H.L. And you are somewhat sure that is how it went in the field of psychology?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well at least at the academic level yes, at the top universities and especially the Ivy League Schools. I would almost bet everything on the fact that it paralleled the experience within the neural science field. But at the time, in the middle of it all, you can’t see the forest from the tress, and it was very frustrating.
				</p>
				<p class="h-l">
				H.L. You were disappointed by their silence.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and angry; frustrated. When you don’t know who the enemy is, you have a tendency to strike out at people that were once more friends than foe.
				</p>
				<p class="h-l">
				H.L. I imagine so, explain.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, like everything else I had it backwards. I felt the psychological community would be receptive to The Theorem and the neural science community would turn its nose up at it. This was just the opposite of what occurred; the neural science community embraced it, and the psychological community didn’t react.
				</p>
				<p class="h-l">
				H.L. You say like everything else, what do you mean by that?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well it happened with The Theorem model. I felt the immunological aspects of it were the weakest link of the developmental model. I really came this close to leaving them out.
				</p>
				<p class="h-l">
				H.L. They were the strongest aspect?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I wouldn’t go that far, but I do think that this aspect of the model has received the most interest.
				</p>
				<p class="h-l">
				H.L. Perhaps, because it is the most tangible.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well as tangible as the immune system can be, it’s kind of like the wind; it blows all over the place.
				</p>
				<p class="h-l">
				H.L. That’s good, I like that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> But I really had high hopes for the field of psychology. You know for years they have been getting pushed around by their younger brother; neural science, almost to the point of irrelevancy. Their younger brother, so to speak, had all the flashy tools and hardware and was making amazing strides.
				</p>
				<p class="h-l">
				H.L. Psychology was somewhat left behind?
				</p>
				<p>
				<span class="douglas">Douglas:</span> In a way, though many psychologists today would likely disagree. But it kind of seems to have had its glory days in the 1960’s or 1970’s; back in the era of peace and love.
				</p>
				<p class="h-l">
				H.L. I know what you are saying.
				</p>
				<p>
				<span class="douglas">Douglas:</span> In this current environment they spend a large amount of time bickering about terminology, renaming old concepts and so forth. You see once neural science advanced, then psychologists and for good reasons, were less likely to forward psychological theories. The fear was that they would be disproven by neural science.
				</p>
				<p class="h-l">
				H.L. Their younger brother?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, their younger brother. The Theorem is different, it is a model built out of neural science first, but still includes a primary focus of psychology.
				</p>
				<p class="h-l">
				H.L. So you had hopes they would embrace it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, after all The Theorem is the golden spike; connecting neural science to psychology, but for a myriad of reasons, those plans were derailed. At the very least they were sidetracked temporarily.
				<span class="break"></span>
				I felt they could say to the neural science community, with The Theorem; you can have all the expensive tools in the world, but ultimately the answers, your answers came from one man in a room with a pen and a pad. If it wasn’t for this, you’d still be playing nothing more than an expensive game of ‘pin the tail on the donkey’. That’s the true value of a psychological theory in application to neural science.
				</p>
				<p class="h-l">
				H.L. Expensive indeed, it is a big dollar game. Maybe they could throw the papers in their lap.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yeah, so true, and funny. No I don’t think they would do that.
				</p>
				<p class="h-l">
				H.L. That is very interesting though, it is quite a discovery.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Thank you. Yes, it is.
				</p>
				<p class="h-l">
				H.L. Are you ready to get to the core of the topic?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, we should, otherwise we are in for a very long day and night. It seems like forever since we talked about those events. I guess I just wanted to forget all of that happened.
				</p>
				<p class="h-l">
				H.L. Like you said, the pain makes you run off topic.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It really does. The entire ordeal is so painful. It’s more than that even, as dealing with a narrative, an interview where you are such a victim. The natural counter reaction for me at least, is to want to insert some self-importance in there so as not to feel so small; so stepped on.
				<span class="break"></span>
				At the heart of all of this is the belief by others that one man’s work is not important and therefore should be nullified.
				<span class="break"></span>
				Oh, you can attach all the elegant labels to it; censorship, suppression and so forth. Still at the belly, it comes down to the individual. All victims of censorship share at their core a fundamental flaw in communication, a basic weakness in character or a particular vulnerability ripe for exploitation. You can’t escape it; I can’t escape it. So no matter how I decorate this, and try to conceal that reality from the reader, it will float to the surface.
				</p>
				<p class="h-l">
				H.L. That’s a very brave admission. I am sure that will come through as well.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, unfortunately, I am sure it will.
				</p>
				<p class="h-l">
				H.L. Back to the events; by January 2015 you had left Tennessee and you went to work?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I went to work for six months and saved money. After those six months, I met back up with my friends in Central Missouri.
				<span class="break"></span>
				But things were definitely picking up steam in (Washington) DC after I left. In fact it really had started before I left.
				</p>
				<p class="h-l">
				H.L. What do you mean?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Eric Holder.
				</p>
				<p class="h-l">
				H.L. You mean Barack and Eric?
				</p>
				<p>
				<span class="douglas">Douglas:</span> It was a big deal for President Obama to have Eric Holder leaving the post of Attorney General, resigning at the end of September, 2014. Holder wanted no part of suppressing a book or <span class="italic">The Legacy Letter</span> or the mushrooming storm he could see coming. This wasn’t going to be his legacy, no way.
				<span class="break"></span>
				Holder felt if they were caught, perhaps President Obama may get off with a severe slap on the wrist, but Holder knew he would end up the fall guy. He had worked too hard, and too many people believed in him, including many African-Americans. While it is hard and sad to believe that it took this long; Eric Holder was the first African-American Attorney General of The United States.
				<span class="break"></span>
				Truthfully, I did a double take when I read it. But it is true. He was our first. So this only added higher expectations, and there was no way he was going to let everyone down.
				</p>
				<p class="h-l">
				H.L. They were friends as well.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, you are right and perhaps that is more significant than anything else.
				<span class="break"></span>
				Harry Truman once described The White House as a ‘prison’. It is a lonely place for a president and was about to get much more so for Barack Obama. He had just lost a good friend, someone he could distract himself from the ominous implications of his actions with, by descending into trivial small talk; the way all friends do.
				</p>
				<p class="h-l">
				H.L. That’s a good point.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Not only that. He could see through Holder's eyes and actions how severe and dire the situation was. Eric Holder was a brave man and he was heading for the hills.
				<span class="break"></span>
				Obama had to wonder, should he do the same? I am sure he wished he could resign; he wished he was just attorney general and could go home to his private practice. But he was the president, and the job he once only dreamed of was quickly turning into a nightmare that had no sign of ending.
				</p>
				<p class="h-l">
				H.L. He was really stuck, wasn’t he?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely, and there are just normal and typical psychological reactions to a defection. It doesn’t matter what kind. It may be a neighbor you don’t talk to anymore, a girlfriend or boyfriend. Maybe your kids move away. All of these things affect you. But someone who has been in your administration, day in and day out for close to six years; it’s a big loss.
				<span class="break"></span>
				But to Barack Obama this is even more intense, as he has major issues with desertion. Remember he was sent away from by his mother when they lived in Indonesia. He was sent to Hawaii to live with his grandparents.
				<span class="break"></span>
				To enviously watch Eric Holder leave, to see him go. Could Obama ever get over this cover-up? Would it ever go away, or would it dig at him forever? These would be questions he would have to be asking himself at this point, though from now on there was no one there to reply to him.
				</p>
				<p class="h-l">
				H.L. Yes, I can agree that his childhood experience would magnify the loss.
				</p>
				<p>
				<span class="douglas">Douglas:</span> He was a very isolated president to begin with. He was going to have to go all in now. The cover-up in response to <span class="italic">The Legacy Letter</span> and The Theorem was mushrooming into an even bigger mess. To be in something that big and that vast as the cover-up was becoming; well, you can’t tell up from down. You are going to make mistakes. You have no one to tell you, “Hey don’t do that!”
				<span class="break"></span>
				And by the time he is going undertake surveillance on Trump Tower, he will have slid into such a precarious mental state, and much of this is due to the isolation he was about to realize.
				</p>
				<p class="h-l">
				H.L. Sure that makes sense, and to continue with the Harry Truman theme, didn’t he say, “If you want a friend in Washington, get a dog!”
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yeah, I believe so.  There is just no one Barack Obama can really trust at this point, or very few at least. He doesn’t want to reach out to someone new and put this burden on them. He’s not one to do that. He will just bottle it up inside of him; later, it will leak onto those around him to near disastrous effects.
				<span class="break"></span>
				Not to bring up another quote, but this tired one seems appropriate. Hemmingway in The Sun Also Rises:
				<span class="break"></span>
				<span class="italic">How did you go bankrupt? Two ways. Gradually and then suddenly.</span>
				</p>
				<p class="h-l">
				H.L. That one I have heard before.
				</p>
				<p>
				<span class="douglas">Douglas:</span> He had been ‘gradually’ sliding into despair for over six years. He didn’t want to do Hillary or Bill Clinton’s dirty work anymore. So this defection would be a ‘suddenly’ moment. It all was hitting him. The Clintons had pulled him in deep; there was no new realization for Barack Obama in regards to this. But now he was in deep and alone, and this magnified his comprehension of what the price for their association he would pay.
				<span class="break"></span>
				Worse yet he is about to get Loretta Lynch.
				</p>
				<p class="h-l">
				H.L. Not a good choice?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, I believe he thought it was. After all Eric Holder didn’t know anything about Tennessee Appalachian People. Barack Obama didn’t know anything about Tennessee Appalachian People. This was a different world I was living in down there. They are amazing people really, they are so warm-hearted.
				<span class="break"></span>
				But many have their own dialects and customs, and Washington D.C. and the political elite may have well been a million miles away. So Obama sought out someone who was from the Appalachian region, Greensboro N.C. Maybe she could help enhance his understanding of what I was up to in this strange world he knew nothing about.
				</p>
				<p class="h-l">
				H.L. Then you moved.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, then I moved two months later and the president has no better than a spy for Bill Clinton. He is stuck with her.
				</p>
				<p class="h-l">
				H.L. But Loretta Lynch was a good choice, because she was experienced at prosecuting partisan culprits for financial crimes in NYC.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, another message sent, another message ignored. Wall Street yawned. But Obama meant business and she would do what Holder did not want to do. She, through her staff, would prosecute those who the president told her to, without any questions asked or substance discovered.
				</p>
				<p class="h-l">
				H.L. But you moved.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I moved, but as his final warning to Wall Street he would undertake a cold and heartless act in the spring of 2015.
				<span class="break"></span>
				You see many of my potential investors and potential donors were from the East Coast. The men and women on Wall Street were really my initial focus group. And no matter how big you expand; your initial focus, those who you started with always have a special place in your heart.
				<span class="break"></span>
				I loved New Yorkers anyways, while it is not my favorite city in the world, they are most definitely some of my favorite people anywhere. This goes back twenty years or more.  So it was obvious; and anyone watching me would see that this region is where I put my emphasis on. Of course Barack Obama knew this, as he had been watching since almost the beginning.
				<span class="break"></span>
				Now many of these men were of the Jewish Faith. So because of this, do you know what the president was going to do?
				</p>
				<p class="h-l">
				H.L. Punish Israel.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course, the president is going to terrify Israel actually; by putting together some weak, half–wit deal with Iran to prevent them from constructing a nuclear bomb. But it was really just appeasement to Iran, the net result of the deal infuriated Israel as you may remember.
				<span class="break"></span>
				And as you know many of those with the Jewish Faith living in America maintain very close ties to Israel. Not to mention that I had written to many wealthy Israeli Nationals, and realized a substantial amount of interest from them.
				</p>
				<p class="h-l">
				H.L. That is cold-hearted.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It was, and not very smart either. But he wasn’t receiving any respect from the Arab Leaders either. I had written to many Muslims as well, and many powerful men in the Middle East.
				<span class="break"></span>
				But again, the president was blocking all my attempts at receiving funding. So when he held a summit at Camp David in May of 2015, he invited the leaders of six Arab Nations; all part of the Gulf Cooperation Council, only two of the six leaders showed up. The other four snubbed the president, and this rarely has happened in the long storied history of American International Politics. In fact it may have been the first time.
				</p>
				<p class="h-l">
				H.L. He was throwing a party and hardly anyone came.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and while much of it had to do with his negotiations with Iran, a good portion of it had to do with Obama blocking the Arab Billionaires interest in <span class="italic">The Legacy Letter</span>. Billionaires do not like to be told what they can or can’t do; again, many are close friends with the leaders of their country. Also Muslims by nature are very generous and some were sincerely interested in helping out.
				</p>
				<p class="h-l">
				H.L. So by 2016 he will be secretly sending 400 million dollars to Iran.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Very true, he is starting to crack which brings me another observation.
				<span class="break"></span>
				From this point on, when I was monitoring my computer, it was not uncommon to see hits on my website from the Camp David area on the weekends when he was there.
				<span class="break"></span>
				So even when President Obama is supposed to be resting, he is still focused on this cover-up and suppression. As you would imagine, this will all be important later.
				<span class="break"></span>
				Barack Obama is a Harvard educated lawyer who lectures on U.S. Constitutional Law. It will take a tremendous amount of pressure, fatigue, and stress for him to go against everything he knows to be moral and also logical by allowing a FISA warrant anywhere close to a potential presidential candidates residence.
				<span class="break"></span>
				We have a long way to go yet, but he’s starting to show signs already.
				</p>
				<p class="h-l">
				H.L. In contrast, you are out of that stressful situation.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly I am out of Tennessee, I am making money. We are taking about moving to Europe at this point, though we never did. I am very relaxed. Meanwhile the interest in <span class="italic">The Legacy Letter</span> is really starting to grow exponentially, and the growth will continue to flourish throughout 2015.
				</p>
				<p class="h-l">
				H.L. So why did you settle in Missouri; the where and when?
				</p>
				<p>
				<span class="douglas">Douglas:</span> It wasn’t planned; there was really no reason. I was working near there at the time. The house was not remarkable. We moved in to the place in summer of 2015 and would be there for a total of 2.5 years.
				<span class="break"></span>
				In a way though it had to do with logistics and the potential investors; I felt if we stayed on the East Coast, I would alienate the big money on the West Coast. And vice a versa, so the Midwest was somewhat neutral.
				</p>
				<p class="h-l">
				H.L. So you still expected to get the money, to find an investor?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely, demand was high; interest in the letter was higher.
				<span class="break"></span>
				Looking back I don’t know if Missouri was the right pick though. We chose a small town named Concordia, Missouri. It was 50 miles east of Kansas City. The people were very nice, but the town itself was not scenic, just Central Missouri farmlands. The only thing remarkable is that we lived in the shadow of a large church. But again, the people were friendly.
				</p>
				<p class="h-l">
				H.L. What were your plans there?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well not much really. At first I even considered giving up on <span class="italic">The Legacy Letter</span> and starting another book. Then I began working on building another website for The Theorem. My friend was a great help on that site. Essentially in the beginning, we did a little bit of everything.
				</p>
				<p class="h-l">
				H.L. You were tired, you had said.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, we were exhausted. We had really been living like gypsies for four or five years. Before Missouri it was that mess in Tennessee; before that we were up in the Northern Rockies of Idaho, and before that California, South America and living Central America. It was time to slow down.
				</p>
				<p class="h-l">
				H.L. I imagine so. But you kept sending the letter out?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I did, and at a very high volume. I sent copies out at a very brisk pace from summer of 2015 until February of 2016; I believe I sent out close to 5000 copies of <span class="italic">The Legacy Letter</span> during that short time frame.
				</p>
				<p class="h-l">
				H.L. That is a large volume, so you didn’t slow down at all really?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, not really, as it’s easier said than done to slow down. I became very proficient at sending them out as well, and that was part of the reason for the increase in numbers.
				<span class="break"></span>
				When I looked at who was coming to The Theorem website I was quite amazed! The interest was really going strong. The problem was that I had already sent a copy to so many billionaires, and so many CEO’s in America. So I decided to start sending it out to members of the board of directors of companies.
				</p>
				<p class="h-l">
				H.L. Interesting.
				</p>
				<p>
				<span class="douglas">Douglas:</span> But the overall feeling was less frantic than in Tennessee, and general vibe was much more relaxed as well. We figured we were going to be there awhile, and we were.
				</p>
				<p class="h-l">
				H.L. Working at a relaxed pace is nice.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, it was. It was the first time in 15 years that I was able to watch baseball. I was already a big Kansas City sports fan and we went to a few baseball games that year. I just wanted to carve out a sense of normalcy. In fact, we all did.
				</p>
				<p class="h-l">
				H.L. 2015 was the year the Royals won it all, right?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, that was good luck, so that occupied a good deal of my time. Baseball games are very long.
				</p>
				<p class="h-l">
				H.L. Yes, they can be. Shall we go into the web traffic and the prosecutions you told me about?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, it’s a good time for that.
				</p>
				<p class="h-l">
				H.L. Wait there is one question I want to ask first, to get out of the way. I think I know the answer, but the readers may not.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay?
				</p>
				<p class="h-l">
				H.L. You talk about women and men, but mostly you talk about businessmen. So I am confused. Did you send <span class="italic">The Legacy Letter</span> to men only or to women as well?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Now that is an appropriate question. No, I didn’t send it to many women, maybe 300 in total (3%). Here’s why, <span class="italic">The Legacy Letter</span> was written specifically for men; dealing with issues in regards to his quest for immortality, in contrast to women obtaining that naturally.
				<span class="break"></span>
				This was frustrating; it was very frustrating to me. Because I would see a woman CEO and say to myself, “She is perfect, she will invest or donate.” But all I had was this male oriented letter. So it was like sending a woman a pair of men’s socks as a gift. It really made no sense.
				</p>
				<p class="h-l">
				H.L. But you sent some anyways.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I did, and the response was better than I deserved; let’s put it that way.
				</p>
				<p class="h-l">
				H.L. You mean thank you for the nice socks?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly. That’s so true.
				<span class="break"></span>
				Obviously I had planned on writing a letter specifically designed for women. I even started on it, but by that time the prosecutions were getting so heavy, I really did not want to get females wrapped up in that mess; figuring they had enough to deal with in the workplace already.
				</p>
				<p class="h-l">
				H.L. Thanks, this clarifies a lot. Okay continue with the web traffic.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well one of the things I did with my idle time was really fine tuning my comprehension of how to determine who was coming to The Theorem’s website.
				<span class="break"></span>
				You know when I was in Tennessee, I was busy with the task of survival and this method of detection was new to me, so I had not fully mastered it. However, it had now been close to a year and a half and I was really isolating my focus on my methodology of detection. Like I said, it is more of an art form than a skill. By now I had a much better command of my art.
				<span class="break"></span>
				What I noticed was very disturbing as well. As it wasn’t just business people who were being punished, and it wasn’t just people who were interested in investing, but now Obama was going after Hollywood.
				</p>
				<p class="h-l">
				H.L. Did you send them to actors and directors?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No not really. Okay, in all, by the time I was finished I sent out 10,000 Legacy Letters; of those, less one half of one percent went to celebrities. I use that term very loosely too. Maybe 10 were sent to musicians, 10 to actors, 5 to sports figures etc. I would run across their name and 9 out of 10 times, not send it; but once in a great while, I would.
				<span class="break"></span>
				Now the musicians are interesting, they are worth talking about, because what happened there was truly unique. But no, the very few Hollywood types I sent the emails to were not the ones that showed up on The Theorem website. They were other celebrities. And there was no connection to the initial ones I sent it to. At least that is what I could interpret.
				</p>
				<p class="h-l">
				H.L. So how do you think they found out about it?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well in all fairness, some of them were likely there for a while. When The Theorem first came out, and I was on my exodus around the world, I accidentally ran into a couple of big name Hollywood producers and directors. This was back in 2009, so six years before. I told them about The Theorem and the discovery. I can trace many of the celebrities back to these two producers and directors and their work over the years.
				</p>
				<p class="h-l">
				H.L. That’s wild; did you ever send them a Legacy Letter in 2014 or 2015?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No. Truthfully I didn’t even think about it. I suppose I should have, but again celebrities were not my focus, more of an afterthought.
				<span class="break"></span>
				Also, The Theorem may have done quite well in Hollywood when it was in the bookstores back in 2007.
				<span class="break"></span>
				While I do not know this to be true, or have exact sales figures, I have to assume there was some demand there because it was stocked in brick and mortar bookstores in the Hollywood area. This was in contrast to other cities where The Theorem was not stocked on the shelves of the same bookstore chain's stores.
				</p>
				<p class="h-l">
				H.L. Sure.
				</p>
				<p>
				<span class="douglas">Douglas:</span> If you add that to the word of mouth from the billionaires and financially elite; then, as you would imagine, eventually the word spread.
				<span class="break"></span>
				Also, some of the CEO’s of movie production companies received a copy of <span class="italic">The Legacy Letter</span> years earlier. But my focus on them was the fact that they were corporate CEO’s, and no connection or interest in regards to Hollywood.
				</p>
				<p class="h-l">
				H.L. Sure, still they were CEO’s. Still they were businessmen.
				</p>
				<p>
				<span class="douglas">Douglas:</span>  Yes.
				<span class="break"></span>
				It also became interesting when the new Theorem website was up and running. From then on I would see two groups of celebrities. The first were the actresses that were pregnant. This made sense, The Theorem is a book you must read when you are going to have a baby!
				</p>
				<p class="h-l">
				H.L. I would definitely agree with that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> The other group was a little more tragic. Often times they were the older celebrities who had a disorder, cancer or an immune issue. So I would see them on there, I would feel sad, and know that in a few months I may read that they were diagnosed with something. This happened at least twenty or thirty times. So this crystal ball essentially of a name behind my web traffic, not only showed me the good, but also the tragic.
				</p>
				<p class="h-l">
				H.L. So which group was the government harassing?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well neither of these fortunately. They left these two groups alone. But if they didn’t fit into those other groups, it went like this: First, I would see them on my site often, and you could almost feel that they were radiating interest in the discovery. Then a few weeks or months later, all the trash would come out about them. It never failed. And I am not exaggerating, this happened over a hundred times to hundreds of different celebrities.
				</p>
				<p class="h-l">
				H.L. You’re kidding me?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, I am not. And like the billionaires, and the businessmen they likely had no clue as to why they were being targeted.
				<span class="break"></span>
				At first, as is typical for me, I was in complete denial. I said that’s impossible. I already have the fate of highly accomplished businessmen on my conscience; I am not going to take on the burden of Hollywood. But over time it became obvious they were being targeted. They were losing roles in movies, they were being slammed on social media and the men; well, many of them were being accused of just about anything under the sun. Again, it happened hundreds of times. Worse yet, this just stopped a few months ago. So it long exceeded Obama’s term. The liberal loyalists are ruining Hollywood, they really are.
				</p>
				<p class="h-l">
				H.L. That is really something. It’s too bad because they work so hard for their fame.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is so true, I have definitely a new respect for the work they do.
				<span class="break"></span>
				The thing is though there were some who knew about this racket, and knew how to game the system. You see I always try and find the positive even in this tragedy.
				</p>
				<p class="h-l">
				H.L. What do you mean by that?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, it was like a club. If you were on the inside, and you came to The Theorem site too often they would just as likely be rewarded with a big role, or a big interview.
				<span class="break"></span>
				I am telling you, fact is stranger than fiction.
				<span class="break"></span>
				So essentially some of these highly alert ‘A’ list actors knew exactly how to play it; in other words they would go to the website at a low time in their career, and keep returning, and then magically their career would take off again. So they knew they were being watched and they played this dangerous game of chicken with the Liberal Elite and won! They had no real interest in the book, I could tell. They just knew how to tweak the system in their favor.
				</p>
				<p class="h-l">
				H.L. How many did this?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well maybe only between fifteen or twenty celebrities, but, hey it was something to cheer about. There are smart risk takers in every field.
				<span class="break"></span>
				The thing is there was a time when The Theorem website for Hollywood was like a wheel of fortune. They could take a spin, and see where it landed. If they were too big to fail, they won. If they weren’t, they lost. All of this from a book that was out of print, I’m telling you true, this is exactly what happened.
				</p>
				<p class="h-l">
				H.L. So you said it stopped a few months ago, are you sure?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I am sure. It’s done. The villains are on the run, and this is low priority for them now. After the release of this, it will be done forever. This can never happen again.
				</p>
				<p class="h-l">
				H.L. I will not argue with that. You know it’s sad, they have to dodge the casting couch, bypass insurmountable odds and then they are essentially told what they can or cannot read.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I agree; it’s absurd and tragic. Of course you are forgetting they often have to also avoid unscrupulous agents and overzealous paparazzi.
				</p>
				<p class="h-l">
				H.L. Yeah, no thanks. Sounds impossible; I couldn’t even get past the dieting.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s funny.
				<span class="break"></span>
				While this was an interesting revelation, it was very scary to me as well. Because for once I was starting to realize just how big this cover-up was, this intentional destruction of lives. Before that I just thought it focused on businessmen and Wall Street. I had no idea that they would go after actors or actresses. It just didn’t seem possible. I’m telling you Obama was the Spy King, this transcended political ideology.
				</p>
				<p class="h-l">
				H.L. I know at one time he was spying on 35 world leaders.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yeah, I mean just think of that. It is sick, truly sick.
				</p>
				<p class="h-l">
				H.L. You said the musicians; you sent a few to them. How did that go?
				<span class="break"></span>
				I see you’re smiling, so I can guess the answer.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I am. Here’s the story. Finally something positive!
				<span class="break"></span>
				So occasionally over the years as I was emailing, I would hear a song or a lyric and then think I should send that person a copy of <span class="italic">The Legacy Letter</span>. But for some reason I was shy. So finally one week, sometime in or around 2015, I made up my mind to get up the courage to do it. Their email addresses were not easy to find, but I sent the letter to maybe ten or even fifteen famous musicians.
				<span class="break"></span>
				At first I heard nothing, saw no interest on the website or anything. I thought that it was a dud. Then about a year later it started, and it’s like they woke or rose up, and it has not stopped since.
				</p>
				<p class="h-l">
				H.L. Why do you think it took almost a year, were they that busy?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well a bunch of reasons. I think I have it figured out as I have given this a lot of thought, as a year is a long lapse.
				<span class="break"></span>
				I figured maybe at first they were not that impressed with my writing, as these artists are responsible for some of the best prose in recent history; a good portion of it is poetry to music. I cannot write like that, though I wish I could.
				</p>
				<p class="h-l">
				H.L. That’s a good point, a tough crowd.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well they were at first, but of course the content was definitely there, and like you said they were busy. But here’s what I really think happened.
				<span class="break"></span>
				I think they started piecing everything together. I think they started to see the big picture. They could see that The Theorem was being suppressed and censored.
				</p>
				<p class="h-l">
				H.L. Ah yes, musicians don’t like censorship.
				</p>
				<p>
				<span class="douglas">Douglas:</span> No they don’t, not at all. The thing is they will defend it to the end. It doesn’t matter if it’s rap, country or rock. Even if it’s not their type of music; to them, censorship is censorship: period.
				</p>
				<p class="h-l">
				H.L. Then they became more active?
				</p>
				<p>
				<span class="douglas">Douglas:</span> It was as though they figured it out; “Hey, some writer is being censored and he’s one of our fans.” Suddenly it was like the heroes on the posters of my stoned out youth came down from the walls and took action! When I say action, I mean action, they told every other musician imaginable. It was quite a sight. I was overwhelmed.
				</p>
				<p class="h-l">
				H.L. That’s great, like you said, finally some good news.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and don’t think they weren’t punished for it, some were. But really I think they didn’t give a shit. And the thing is they were spread out all over the place, other countries, on tour, everywhere. An already exhausted administration finally realized that they couldn’t catch up with these guys. Their actions really were inspirational to me. It was amazing, just amazing.
				</p>
				<p class="h-l">
				H.L. Like I said they don’t like censorship. They just don’t.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You’re right. The thing is too, looking back, they were smart for many reasons. They may have been thinking about the long game. Many of these musicians have extensive catalogues of music at risk. There was no way they were going to be on the wrong side of a scandal and risk that. Even if it was the liberal elite doing the suppressing, they would not bow down.
				</p>
				<p class="h-l">
				H.L. That’s true, from a business standpoint. They would just ride it out.
				</p>
				<p>
				<span class="douglas">Douglas:</span> One more thing. I think when all of this is said and done, years down the road; when all of this mess is finally uncovered, when insiders begin to testify, you are going to notice something.
				<span class="break"></span>
				I think the action of these musicians, this intense word of mouth, was in many ways the threshold, the straw that broke the camels’ back. While the Obama Administration could certainly target Hollywood as there was a geographical core there, a set location; the music business was so far spread out like I mentioned earlier.
				<span class="break"></span>
				So essentially I believe this was the tipping point, the time when the president just through his hands up in the air, not yet in defeat, but in an overwhelming realization that in the long term he wasn’t going to win.
				</p>
				<p class="h-l">
				H.L. No, that is good. I can see there is more here.
				<span class="break"></span>
				It’s not uncommon for artists to see the value or the trends before they trickle down to the group population in general; perhaps that what he was seeing: A single loss of a battle that had foreshadowed the ultimate defeat in a war.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well put, it was a definitive turning point, and I will not soon forget these men and women, not soon at all.
				</p>
				<p class="h-l">
				H.L. That’s really inspiring. It truly is.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay I know we have a long ways to go, we are not even at the true headwaters of Spygate, but I need to include a last bit of electronic detection.
				<span class="break"></span>
				I hate to change the tone as well. It is a sad and somber event, and then we can get on with the rest.
				</p>
				<p class="h-l">
				H.L. Sad and somber, we already have had plenty of that. And we are just getting started.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Agreed.
				</p>
				<p class="h-l">
				H.L. Go ahead.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, it is very important. Actually this event is what prompted me to start this project anyways. So it is a big deal. This man is a big deal to me. His name is Carlos Ghosn.
				</p>
				<p class="h-l">
				H.L. Well when you say it like that, please.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, well to get there we will have to jump ahead. But we will return. It’s 2017 and the 2016 election is over. Donald Trump is the new President of The United States, and I have long stopped emailing potential investors.
				</p>
				<p class="h-l">
				H.L. You were living in Missouri at the time?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, in a way, but in a different part and alone. In the beginning I was, but this event continued for about a year. Throughout that time I was also living in California and the Northern Ozarks as well.
				<span class="break"></span>
				So I don’t how familiar you are with computers, but I’m guessing anyone can figure this one out. As you are likely aware when you open up your home page on a computer or to your search engine you have shortcuts; These are the sites that you visit more often and clicking on that link it takes you directly into the site. I foolishly still use Google, so that is the search engine I am speaking of here.
				</p>
				<p class="h-l">
				H.L. Yes, I believe everyone is well aware of those.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course. Well anyways there were many websites I would frequent to apply my detection ability and utilize the tool I had created; the technique I had mastered to find the true identity of cloaked visitors who came to my website.
				</p>
				<p class="h-l">
				H.L. Yes, you covered that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, so this particular website I didn’t really use for that purpose. It was a list of executives from around the world; board of directors; CEO’s, etc.
				<span class="break"></span>
				I would utilize this list on the site primarily to find names and not to determine the frequency of who was coming to my site.
				</p>
				<p class="h-l">
				H.L. So you used it for a different purpose. Go on.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, this is correct. This may be a little difficult to convey in interview form, it is much easier if I could show this or demonstrate it to you.
				</p>
				<p class="h-l">
				H.L. You’re doing fine. Continue.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Now this site had a somewhat unique feature. The more relevant the individuals name was to you, or to current events the larger the font of the name became. So for the average consumer or whomever this may be helpful. But for me, this was amateurish and non-precise, so I didn’t really use it for detection; as I had better methods.
				</p>
				<p class="h-l">
				H.L. I don’t quite understand enlarge the font.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, let’s say that I had been searching for a CEO named John Doe. Now the more I search for John Doe, or if he comes to search for me, the larger the size of his name will become on that website. This is just for my search, others will be different.
				</p>
				<p class="h-l">
				H.L. I see, yes. That is interesting I have never seen that, but I will look.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, well I don’t know if other sites do this, but this one did.
				<span class="break"></span>
				Sometimes this bot or increased size of font on the name matched what I was seeing in my results with other names it listed, usually it was somewhat close, and so it was partially reliable.
				<span class="break"></span>
				Now somehow one of these executives’ names, Carlos Ghosn, now former CEO of Renault, became a shortcut. So now instead of entering the website through the home page, I was entering the website through the shortcut with his name on it.
				</p>
				<p class="h-l">
				H.L. Therefore his name kept enlarging.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, you got it. His name kept enlarging. Again, I have no idea how he became a favorite or a shortcut, likely I hit a button on accident one time and just left it there. No matter. So yes his name, Carlos Ghosn, the font size of his name would increase each time I opened it.
				<span class="break"></span>
				It is important to disclose here that all my primary techniques of detections led me to believe that this executive, Carlos Ghosn, was not particularly interested.
				<span class="break"></span>
				In other words, while I had sent him an email, a Legacy Letter, I saw no evidence that I should follow up with him, or that I should be expecting a call from him anytime soon.
				</p>
				<p class="h-l">
				H.L. Sure, you said you sent out thousands of Legacy Letters by the end.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and actually I was done sending out Legacy Letters, and had been for awhile. So I can tell you almost exactly, by that time I had sent out 10,100 emails.
				<span class="break"></span>
				Now remember it’s after the election, President Trump has long moved into the White House. So I feel much safer in some ways, but I am also aware that there are Obama loyalists lurking around the administrative branches.
				</p>
				<p class="h-l">
				H.L. That’s common, especially in the first few years of every presidency.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, of course. So at first when I saw the font size of this Carlos Ghosn’s name increasing, I said to myself. “Well, you better be careful, because maybe they are interpreting the data incorrectly; they may think that he is interested. And you don’t want to get anyone in trouble; bring charges against him especially if this is all a misinterpretation”.
				</p>
				<p class="h-l">
				H.L. So you were concerned that someone on the other side of the web would be interpreting your results, and seeing the font size of his name increase as well.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, someone somewhere was noticing this; they were locked into my computer, my search. This was my concern, but at this point, I didn’t see it.
				</p>
				<p class="h-l">
				H.L. I see. You were gun-shy. Your potential investors had been targeted, and you didn’t want harm to come to anyone else.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but I told myself, I was being paranoid.
				<span class="break"></span>
				I said that would be impossible. Still, I knew I had to change that shortcut. I just felt in my stomach I needed to change it.
				<span class="break"></span>
				Every time I would click on that link, the shortcut, his name; then, I would subtly fret for this man’s future. I was over reactive to the stimulus; an entire stress response, subtle but potent, would overtake me. Indeed I was beat up, beat down and exhausted from the hell they had put me and my potential investors and donors through. Work itself was becoming stressful. To look at the computer was creating mild anxiety, though I could quickly disarm it; still it was there.
				</p>
				<p class="h-l">
				H.L. I can relate to that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> But I didn’t change it. I would just enter the Site through Carlos Ghosn’s name. So here is what happened. Now remember there are close to a 1000 names on this list of executives and maybe more; this is important, it’s not a short list.
				<span class="break"></span>
				So while I knew I should delete that shortcut, I failed to do so. I wasn’t being lazy. It was too painful to accept that I might be that toxic. It was too painful to accept that this was not over. It was too painful to accept that the ushering in of the new administration was not like some magic wand that would erase the nightmare.
				<span class="break"></span>
				My bedrock, my very foundation demanded that the trauma I experienced was all over. But it wasn’t. Not all.
				</p>
				<p class="h-l">
				H.L. I think I get it, to have changed the shortcut, to have erased Carlos Ghosn’s name would to have been to accept it wasn’t over. You needed this to be over.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So when the charges were brought against Carlos Ghosn, I knew exactly why, and I was devastated. My entire world, what little bit of a self I had regained since the election, all vanished in an instant.
				</p>
				<p class="h-l">
				H.L. So let me get this straight. You are essentially saying that because you did not change your shortcut on your home page and delete Carlos Ghosn’s name he was prosecuted? I really think you are putting too much weight on yourself with that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> See! See how easy it is? Exactly what I used to tell myself, but no it is true. And I can all but prove it to you as well. Because after the charges were brought on him, I did something.
				<span class="break"></span>
				I went online anonymously, but not completely masked; this so that those who were behind the sham prosecution knew it was me.
				</p>
				<p class="h-l">
				H.L. Sure.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I called them out; I said those responsible will end up in prison. Well the next day, of course, the size of the font went from extra large to nonexistent! Now it had been there large, the most massive of all names, for over a year. His name just disappeared. In other words they panicked and realized they were sloppy with their work. So they rushed back and tried to cover their tracks, but by then I had already caught them.
				</p>
				<p class="h-l">
				H.L. That is amazing in a sad way. Basically you were one step ahead of them but they didn’t know it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, as far as I know they were using the size of that font of that website to determine who was innocent and who was guilty; to me at that point it was amateurish and child’s play. But ultimately a man suffered for my failure to delete that shortcut.
				<span class="break"></span>
				</p>
				<p class="h-l">
				H.L. So you are sure that if you would have deleted that shortcut he would not be prosecuted today?
				<p>
				<span class="douglas">Douglas:</span> Yes, absolutely. Unless, by one of a thousand chances Carlos Ghosn was particularly interested in investing (the amount of names on that site), but again I saw no evidence of this; and as you can tell my methods of detection were far advanced to the Liberal Elite hackers and coders at that time.
				</p>
				<p class="h-l">
				H.L. So where do you think that those hackers were?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Who knows, this I couldn’t tell you.
				<span class="break"></span>
				Look, I could give at least twenty names of almost this exact event or similar events happening. Probably I could give you more. But ultimately one of those would be wrong, or there would be some validity to the charges. Does that make the other 19 okay?
				<span class="break"></span>
				No, it doesn’t!
				<span class="break"></span>
				The only reason I mentioned this one, here now, is that it well exceeded Obama’s reign and that the cover-up and bogus charges are still continuing; this in the wake of the Obama administration, his loyalists. I was very upset.
				</p>
				<p class="h-l">
				H.L. I could see why you’d be upset.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Upset is really not strong enough. I wept for days, maybe weeks and months. I went from hating myself to hating the Liberal Elite and it never ended, it was a circle I could not escape from. And probably the tears I cried, and there were many, were not just for him but likely for all the potential investors that had been falsely prosecuted or harassed.
				<span class="break"></span>
				The only thing that rescued me from that circle of self-loathing was the determination that whatever the personal cost, whatever the embarrassment and disbelief I would encounter, I would tell this story. I would get the truth out. And that is the day I starting working on this, on my notes for the narrative that has now evolved into this interview. It was well over a few years ago, likely longer.
				</p>
				<p class="h-l">
				H.L. Well I am glad you decided to share it. Every man has his limits, you had reached yours.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I had. I have. And with these people; the French and the Japanese and any American co-conspirators who brought these false charges against this good man, who is quickly transforming into a great man, you better run! Because you will be prosecuted in the World Court; with everything that is in me, I will see to that.
				<span class="break"></span>
				Sorry, I had to get that out.
				</p>
				<p class="h-l">
				H.L. It’s okay, take a few minutes. We have time.
				<span class="break"></span>
				That’s just wrong. I’m sorry. I agree, these people need to be prosecuted.
				<span class="break"></span>
				So you’re saying that this was not an American operation, but an international operation?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes. You see they were limping now, these leftist elitist. They were like a tired old, injured lion who could not hunt for itself. So it would go down to the village and prey on the inhabitants.
				<span class="break"></span>
				They were out of the loop; they did not have the same access to surveillance they once did, they could only see things obstructed, obscured. Therefore they began to misinterpret the data. It all, in a horrible way, made sense.
				<span class="break"></span>
				Or else they misinterpreted the size of that font, as me somehow communicating with Ghosn, somehow he was planning on secretly investing in the Theorem; the whole incident is so ridiculous. I don’t even want to stoop to the low level of intellect these half-ass coders were applying for interpretation.
				<span class="break"></span>
				The Obama administration, with as much scrutiny as it received internationally, was able to export this archaic liberal ideology to a few countries. Shockingly, Obama found someone weaker than himself in the French leader, and sold him that repackaged, passé liberal agenda.
				</p>
				<p class="h-l">
				H.L. The Japanese too, it sounds like.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, it’s like join the party, help destroy America! It’s sad; vultures circling high above the rotting flesh of our democracy in decline.
				</p>
				<p class="h-l">
				H.L. Well said.
				</p>
				<p>
				<span class="douglas">Douglas:</span> While I have spent very little time in Japan, it is the opposite with France. Paris was once my favorite city. They are amazing people, but they need to wake up and purge those who were responsible for this awkwardly focused alliance with the Obama administration. This is wholesale censorship, and the French citizens risk the historical perception of being seen as oppressive and backwards rather than culturally enlightened. What a shame!
				</p>
				<p class="h-l">
				H.L. It is for many reasons. Europe is a mess.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It really is. It’s like watching a lost puppy wandering around the city.
				</p>
				<p class="h-l">
				H.L. What do you mean by that exactly?
				</p>
				<p>
				<span class="douglas">Douglas:</span> William Blake once said, <span class="italic">“The eagle never lost so much time as when he submitted to learn of the crow.”</span> I certainly see Europe this way now, trying to follow us, to learn our crow ways. They are becoming nothing more than a cheap of imitation of America. And this incident, following outdated liberal polices rehashed and repackaged by the Obama administration is just another example that reinforces my belief in that.
				</p>
				<p class="h-l">
				H.L. That’s very good. Blake also said, along the same line, <span class="italic">“No bird ever soars too high if he soars with his own wings”.</span>
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, that’s my point exactly. That is what Europe needs to do, fly with its own wings and quit trying to copy ours. They have centuries of culture, centuries! They need to embrace that. They need to quit being embarrassed of their perceived inadequacies and start to embrace them again as qualities. Don’t measure yourself against America; we are too young for that. We are only an experiment. That’s it, nothing more and nothing less.
				</p>
				<p class="h-l">
				H.L. Good point. After all there may be nothing left of us after this. It’s a shame. It really is.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and it’s also a shame I have to talk about all of this because it is embarrassing as can be, and very painful.
				</p>
				<p class="h-l">
				H.L. How is it embarrassing?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well I’m still a man. I don’t play a very good victim. As men we want to win, at least in my case I do. We want to brag, we want to thrive! We want to show how we escaped from the jaws of the lion, not talk about how it swallowed us.
				</p>
				<p class="h-l">
				H.L. Well you will feel better when you are done. I can see the changes on you already.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Maybe. Maybe I will feel better, I don’t feel any changes.
				<span class="break"></span>
				No matter, another reason this example is important is that it illustrates how this cover-up by that time had long exceeded the U.S. borders. I could name other conspirators, at least 20 more, but if I got one wrong, this would be tragic. So I will err in the name of caution.
				</p>
				<p class="h-l">
				H.L. That’s not a bad idea. This probably isn’t going to be the best medium for that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You’re right, we would be here a month if we went over every incident, and we would have to hustle to be done by then.
				</p>
				<p class="h-l">
				H.L. I get the point though, I can certainly see this cover-up expanding and growing well beyond our borders here.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Just wait until the last day, or even the one before that; this is nothing yet.
				</p>
				<p class="h-l">
				H.L. I know it is disturbing, these are people’s lives and careers, all over the globe. It just keeps mushrooming.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Welcome to America. From Michigan we export cars, from the Midwest we export wheat; lumber is shipped internationally from the Pacific Northwest. But our biggest export is from Washington D.C. and it is larger than all the others combined, and we proudly call it: censorship.
				</p>
				<p class="h-l">
				H.L. It is ridiculous, and very sad.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I guarantee you right now leaders in many countries see our censorship here, because of this cover-up, the same way we view the censorship in China. It is unforgivable. It is a serious violation of international civil liberties and human rights. Whatever those really are?
				</p>
				<p class="h-l">
				H.L. It’s always easier to see the weeds in your neighbor’s yard than your own.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well put. Very well put.
				</p>
				<p class="h-l">
				H.L. Thank you.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay. Are we there yet; is it election season?
				</p>
				<p class="h-l">
				H.L. Yes. Just take a minute.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I will. It’s just all so upsetting. It’s just all so foul.
				<span class="break"></span>

				</p>
				<br />
				<p class="h-l">
				H.L. So, you obviously felt you had a vested interest in the outcome of the 2016 election.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, and no. Again, I am not too bright that way. I always liked Hillary Clinton. But I also like Donald Trump, so it was interesting.
				</p>
				<p class="h-l">
				H.L. Yes, but knowing what you know now, you must have been concerned for your future should she have won.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, yes. But again, my mind couldn’t see that. It‘s hard to explain. Plus you are assuming that I was able to process all of these events that were occurring to me in real time. It just wasn’t the case, it’s not how my brain functions; it’s not how anyone’s brain functions in response to trauma.
				</p>
				<p class="h-l">
				H.L. I can see that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course I liked Donald Trump, he was a billionaire. I had spent close to two years writing and studying these people at that time. But you have to realize that my family is filled with a bunch of Democrats. I grew up in a sleepy seaside coastal California town inhabited by hippies and dropouts. So it wasn’t that easy to switch sides.
				<span class="break"></span>
				I was a liberal as you can be. And I mean that.
				</p>
				<p class="h-l">
				H.L. How so?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, well let’s put it this way. When I was 12-years-old, I saved up my money from my paper route to purchase a subscription to <span class="italic">Mother Jones</span> magazine. How much more liberal than that can you get? Who even does that?
				</p>
				<p class="h-l">
				H.L. I find it really hard to believe that you did that at 12-years-old.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, you’re probably right. Come to think it I was 13 at the time, but not a day older because I stopped my paper route shortly thereafter. But I was a liberal through and through. My girlfriend in junior high was even arrested for blockading a nuclear power plant. That is what she told me at least; I proudly wore the T-shirt she gave me from demonstration for years. And the big event of the summer was the local No Nukes rally and concert. Even my high school was just ninety miles south of Big Sur. No; I grew up in a different world, one where you were indoctrinated with liberal ideals, and I flourished in that world.
				</p>
				<p class="h-l">
				H.L. This must make it all the more disturbing to realize what they have done to you. What they have done to the Democratic Party.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course it does, it is heartbreaking. But at the time I was still in denial.
				<span class="break"></span>
				Look, no one wants to see themselves that small. So I took solace in the fact that the events were so unbelievable that I could hide from them. I wrapped myself in the blanket of the belief that what was happening to me could not be happening; this was the blanket that kept me insulated from reality.
				<span class="break"></span>
				While I could intake the experience, the events and the observations on a conscious level, my subconscious was out to protect me from assimilating that reality. So I lived in denial.
				</p>
				<p class="h-l">
				H.L. Sounds like a fancy way of saying you were rooting for Hillary Clinton.
				</p>
				<p>
				<span class="douglas">Douglas:</span> If it does, it shouldn’t. No, I voted for Donald Trump: I definitely voted for him, and will again. Hillary Clinton must never be president.
				</p>
				<p class="h-l">
				H.L. I would agree.
				</p>
				<p>
				<span class="douglas">Douglas:</span> But at the same time Hillary is such a wild card. It was good to see her on stage. How that women can handle all the pain inside of her. As someone who has made a major discovery in human behavior, she is a fascinating case study.
				</p>
				<p class="h-l">
				H.L. I can see how she would be.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It’s like filling an old cup with water and watching for where the leaks spring from.
				</p>
				<p class="h-l">
				H.L. That’s a good one.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Of course I knew Bill Clinton would never let her win. She could have been president twice by now. He will only give her so much line; then, he will set the hook, and she will realize a jerk and understand she must patiently await her fate as he reels her back to the boat.
				</p>
				<p class="h-l">
				H.L. I agree. You just wonder how many times they will drag her out of the barn for a race she will never be allowed to win.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I don’t know, modern science is miraculous. The pharmacology of power is a heavily guarded and effective secret.
				</p>
				<p class="h-l">
				H.L. Ever since Kennedys’ ‘pep pills’ or even before that I suppose.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, they shoot up some of these women nowadays with so many hormones; they barely resemble their old appearance.
				</p>
				<p class="h-l">
				H.L. You think Bill Clinton reels her in by cheating?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I think he picks his moments. He is so ineffective with her now, his attempts, so blunted that he really has to work at it in order to destroy her and bring her down. He just has no plans of ever releasing his prisoner, his hostage; his Hillary.
				<span class="break"></span>
				It’s hard for him to accomplish this for a multitude of reasons. One, she is numb to it. The second is more biologically based and more permanent. In The Theorem you realize that after menopause, the reproduction model exempts the female in many ways for obvious reasons. Therefore like the male, she will be more interested in the company of females, emotionally speaking.
				</p>
				<p class="h-l">
				H.L. Yes, I remember that; to the dismay of many grandfathers around the world!
				</p>
				<p>
				<span class="douglas">Douglas:</span> She probably just stays out of habit.
				</p>
				<p class="h-l">
				H.L. Or the hormonal injections, they can increase interest.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Excellent point; very observant.
				</p>
				<p class="h-l">
				H.L. I don’t want to go into this anymore.
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, me either. It‘s getting creepy.
				</p>
				<p class="h-l">
				H.L. She didn’t seem too interested in being there. I have to say that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> No like you said, they just drag her out of the barn. I am glad you brought that up. Because now all the work we did on setting up the grandmother’s interest in the grandchild should pay off. Here’s a perfect example.
				</p>
				<p class="h-l">
				H.L. It will; I agree. Still, I want to hear all about it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, it’s that subconscious quest for immortality. Why gamble with immortality, your legacy, when you can go relax and enjoy your grandchild; knowing he or she may grow up to be president one day. And it all started with her. Or maybe it will be her great-granddaughter someday she will be the president, the list goes on. It’s just more of a guarantee. It’s more certain those generations will go on forever.
				<span class="break"></span>
				She can look at that child and see it all evolved from within her; the immortality birthing machine, her womb. It’s a powerful emotion and realization men do not experience. We have been over this.
				</p>
				<p class="h-l">
				H.L. So her quest for immortality was quenched by that point. They basically had to drag her out of the nursery.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, now you see it. But you put someone with those subconscious reservations, those subtle but deep biological and psychological distractions, against someone like Donald Trump and you’re going to get massacred.
				</p>
				<p class="h-l">
				H.L. He was very hungry for it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> He was, and it’s hard not to cheer for someone like that, especially when the odds were stacked against him in the beginning.
				</p>
				<p class="h-l">
				H.L. Yes, I agree.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I imagine Donald Trump, when he hit the campaign trail, must have felt somewhat like Rip Van Winkle; like he had been asleep for many years.
				</p>
				<p class="h-l">
				H.L. Why do you say that?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well America has changed. It has changed so much, every day, every year. I hardly recognize it.
				</p>
				<p class="h-l">
				H.L. Why do you think it’s changed, I don’t get it exactly.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well I do. I can give you an example, although it’s really going to make me feel old.
				</p>
				<p class="h-l">
				H.L. Go ahead.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well my great-grandparents didn’t have a lot of money. In short they were poor, but not white trash. They lived in Ontario, California; in a trailer under the path of the airport. Years ago it was no big deal, but as the airport grew, the planes became larger and larger and the air traffic increased. So of course eventually each time a plane would take off, the entire trailer would shake.
				</p>
				<p class="h-l">
				H.L. Sounds like a scene from a movie.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It really does, but it was real. The trailer was very small. There was only one bedroom. They saved for years and finally were able to build an extension of five feet onto their trailer. This extension was a big deal for them.
				<span class="break"></span>
				I bring this up because they had four children. Now all of these four children were much better off financially than they were. Two of them owned businesses; one of these businesses was very large. Their other two children were both very successful and financially solvent as well.  Two of the children were WW2 Veterans, and my great-grandfather served in WW1.
				<span class="break"></span>
				So anyways, as poor as they were; whenever they would talk about their children and about the sacrifices they made for them, the little trailer would light up with love. Suddenly, as a kid, I felt I was in a mansion.
				</p>
				<p class="h-l">
				H.L. That’s a great story, what a generation! So you’re basically saying that now it’s the opposite, the kids live in the trailers and the parents are better off.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, in many ways, in many parts of the country it’s true.
				</p>
				<p class="h-l">
				H.L. I think so.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It was as if the baby boomer generation never learned how to give to their children. They became selfish. It’s like they never stopped rebelling against their parents. Oh, they would help the kids out but their hearts were not into it. And when your heart is not into something like sacrifice for a future generation, it just doesn’t work.
				</p>
				<p class="h-l">
				H.L. It’s a good point. Why do you think that happened? The economy?
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s the easy answer, but I don’t believe it’s the right one. I think that many parents; many people of that generation are stuck back in the past with their own unmet childhood needs.
				</p>
				<p class="h-l">
				H.L. Like the Clintons?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well I think they are good parents, but the unmet needs part, yes. In fact it is everything behind the events that happened. It’s all consuming.
				<span class="break"></span>
				Just look at the movie trends five or ten years ago, though it’s probably been longer than that now. They were all symbolic of people felt about what was happening in their life.
				</p>
				<p class="h-l">
				H.L. I don’t understand.
				</p>
				<p>
				<span class="douglas">Douglas:</span> There was a bunch of movies about vampires. This generation is getting the blood sucked out of them by their parents. The symbolism was overwhelming.
				</p>
				<p class="h-l">
				H.L. That’s good.
				<span class="break"></span>
				How about zombie movies? The parents never go away. You think they are done fulfilling their needs, but they rise from the dead and still want to devour your time.
				</p>
				<p>
				<span class="douglas">Douglas:</span> And energy! That’s a good one. Or police shows, and true crime; because everyone feels like a victim, or actually is one, of some twisted childhood. In those shows you can typically see justice to the perpetrator served within an hour. In real life, in our life, it’s not that simple.
				</p>
				<p class="h-l">
				H.L. No it’s not. How about space movies they want to get far away from these people.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Those are for another reason, you can reread The Theorem to learn that.
				<span class="break"></span>
				But you’re right; you can blame people for fantasizing about getting out of here, to escape from those who hold you down. Anyways we could go on and on. The point is; it’s everywhere.
				</p>
				<p class="h-l">
				H.L. You said earlier this morning before we started where you grew up in California was bad.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but what I didn’t tell you, at least we warn you; right at the border we warn you about how bad it can get.
				</p>
				<p class="h-l">
				H.L. What do you mean?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well, think about it. You drive into California on Interstate 80 from the east and not ten miles in is the Donner Party Memorial.
				</p>
				<p class="h-l">
				H.L. I have seen that, so? What does that have to do with anything? It tells you about The Donner Party and how they survived on the pass on the way to California, and how they were snowed in and so on.
				<span class="break"></span>
				And of course they were forced to resort to cannibalism to survive.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, but here is what it is really telling you. It tells the children; be careful! You are entering a place where if your parents miscalculate, you will be eaten as a meal. It is right there when you enter California, it's 20 ft high. It tells kids you better hope mom and dad don’t get lost in Reno or dally in Carson City because you may become supper.
				</p>
				<p class="h-l">
				H.L. I see what you are saying, it is a morbid monument. That’s very perceptive.
				<span class="break"></span>
				Actually that makes perfect sense.
				<span class="break"></span>
				It also tells the Native Americans that if you are naïve enough to help the white people you may get chopped up and become dinner yourself.
				</p>
				<p>
				<span class="douglas">Douglas:</span> See, now you are getting it. There are signs everywhere, and kids pick up on that stuff. It never goes away. We had to learn all about it in school. It was uncomfortable, yet revealing. That’s California, perhaps the most selfish place on earth. No need for subtle symbolism, literal purgation of the young revealed right at the border!
				</p>
				<p class="h-l">
				H.L. I was just thinking when you said that. Remember <span class="italic">The Grapes of Wrath?</span>
				</p>
				<p>
				<span class="douglas">Douglas:</span> Very good. Another fine example right there, many read it in high school; the baby dies in the end and the hungry grown man crowds the vacant breast. That was the San Joaquin Valley; that was California. Sure.
				<span class="break"></span>
				Steinbeck was trying to tell everyone something, California was sick. He even said something was evil in the Salinas Valley, the place where he grew up. He witnessed it first hand, likely in his own home.
				<span class="break"></span>
				In peoples desperation to prosper in the Golden State nothing is sacred, especially infancy and childhood. America in decay, the old, old story; told with a new more potent twist on the westward journey!
				<span class="break"></span>
					Of course it’s not just California anymore. It’s everywhere.
				</p>
				<p class="h-l">
				H.L. I see it. Someone needs to step up and sacrifice for the next generation.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, but they don’t. I remember maybe 20 years ago I first saw the sticker on the back of an RV, ‘We are spending our children’s inheritance.’
				<span class="break"></span>
				Now you see those stickers are faded but the intent still remains. I thought to myself, yeah but you will drive up to your kid’s house, hog up their driveway and annoy them with your visits; all the time rubbing your wealth and indifference toward their well-being in their face.
				<span class="break"></span>
				They harvest the energy of youth, never leaving a fallow field.
				</p>
				<p class="h-l">
				H.L. That’s so true; you can’t imagine the kids will like that.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It is the generation of cashing out your life insurance policy so you can spend it before you go. It’s about cashing in the equity of your home and taking that dream vacation, while your kids can barely afford rent. It is mortgaging the children’s future to fulfill parents unmet needs.
				<span class="break"></span>
				Children used to do better than their parents, now not so much. It’s not the economy as there is plenty of money out there to be made, plenty. It’s living off the energy of children; the purgation of youth.
				</p>
				<p class="h-l">
				H.L. That’s right, young people used to have children, now all they can do is muster up enough energy to have pets.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So true, they are being sucked dry and they don’t even realize it. You know America is a great country, probably one of the greatest in the world. It’s my birthplace, so I believe we are the best.
				<span class="break"></span>
				However it’s no accident how we became so big so quickly.
				</p>
				<p class="h-l">
				H.L.  You spoke of that earlier, more to add?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well we rose on the backs of others. First we built on the land of the Indians, then with the labor of the slaves. Finally when that was over, people would build farms on the backs of their children. They were cheap labor. When the kids couldn’t take it, they moved to the city. But who are you going to live off of and get energy from in the city?
				</p>
				<p class="h-l">
				H.L.  Maybe immigrants, but mostly it’s your children. Your kids, that is all that there is left.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s right; it’s all that there is left. So here we are.
				</p>
				<p class="h-l">
				H.L. Here we are.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It’s a big mess.
				</p>
				<p class="h-l">
				H.L. I think you could even apply what you are saying to the current pandemic crisis.
				</p>
				<p>
				<span class="douglas">Douglas:</span> How so?
				</p>
				<p class="h-l">
				H.L. Well everything is about preventing the spread of the virus because the elderly are susceptible and weak to it, right?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, of course.
				</p>
				<p class="h-l">
				H.L. While it makes sense in a way; at the same time you never hear about the impact on the young people. For example the high school sports and the high school proms that never happened. You know you only get to be young once. The elderly that the youth are sacrificing for never went without those things.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is a very good point. You only get to be young once, but when the world is run by those resentful of youth or still living in their youth or living with unmet needs of their youth, well then it gets crowded.
				</p>
				<p class="h-l">
				H.L. And there is only room for one group, so the young people get pushed aside.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly. It’s like the young people think if they go along with it, keep sacrificing for the older generation then they will be left something for their good intentions. But they won’t be left a thing. They won’t be left a dime. After all, the older generation feel they are entitled to everything; this selfish class.
				<span class="break"></span>
				While that is hard to accept, tough to swallow, it is true.
				</p>
				<p class="h-l">
				H.L. Good point. They wouldn’t get a dime. There will be some very disappointed young people out there when they realize all the sacrifice has been for nothing.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You know one thing I learned about many of the ultra wealthy, and I have obviously unintentionally spent a large amount of time studying them, is that they are smart.
				<span class="break"></span>
				They make sure the next generation gets their money when they leave. This is most of them, I would say 97 percent. These 97 percent of the wealthy are some of the most gracious, giving people in the world.
				<span class="break"></span>
				But then there is the 3 percent.
				</p>
				<p class="h-l">
				H.L. Yes, I see what you are saying. They are not exempt from these social changes either. Some of those billionaires are not leaving the money to their kids. I read that in the news.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is exactly what I was going to say; the 3 percent. To me that is foolish, and selfish. What these super-manipulative individuals try and do is define money as though it has a character, a quality. The fact is that money is not bad, money is money. Money is not evil, people make it evil. And unmet needs make people evil.
				</p>
				<p class="h-l">
				H.L. Really, what does it say to the kid, not much.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Actually it says everything. It says you are an asset I can milk. You are company I can flip and liquidate. You are valueless. I think more of the charity down the street than you. It’s not right.
				</p>
				<p class="h-l">
				H.L. I agree it’s the kid’s money they had to put up with you.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s it. The truth is in many cases, even most cases, if you are worth 30 or 40 billion dollars, you are screwed up 30 or 40 more billion times than the average individual. It’s a sad reality and people don’t want to see that, but it’s true. Publicly we don’t see that.
				<span class="break"></span>
				I am not putting down billionaires, not at all. They serve a huge purpose in society. They are the symbol and the motivation for the guy who is working for minimum wage and has high ambitions. They are the dream he is seeking to obtain. Without billionaires everyone would be much poorer, trust me on that. But fair is fair, if these children had to endure you; pay up.
				</p>
				<p class="h-l">
				H.L. That’s really so good.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I mean I hope to have some money someday. While I am far from perfect, everything I do ultimately is for my children; if I didn’t believe that I would jump off a bridge. I just couldn’t live with myself. And when I go, if there is any money it will go to those who endured me in my hard times and not flattered me in the good ones. That’s only right.
				<span class="break"></span>
				Charity is great, not knocking it, but the way some of these people treat their kids; the ones who will actually need the charity is their future decedents. That’ not wise.
				</p>
				<p class="h-l">
				H.L. I agree; it’s never been harder to be a kid. I don’t care what anyone says.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I think you are right, and like thieves in the night they are even now stealing young people’s sexuality. While the old guys roll their eyes; for young people today in America and the Western World, many are confused about their own sexual identity.
				<span class="break"></span>
				Like you said, mom has traded in the pink for a business suit and she is not coming home anytime soon. Men want women more, women want women more. It’s a mess.
				</p>
				<p class="h-l">
				H.L. At sixes and sevens.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, at sixes and sevens.
				</p>
				<p class="h-l">
				H.L. So how did we get here?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Slowly, then suddenly I guess.
				</p>
				<p class="h-l">
				H.L. No, I meant how did we get here; to this topic?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Oh, I don’t know, but we can circle back, we can use this.
				<span class="break"></span>
				You know in the 1960s and 1970’s the Democratic Party was really built on rebellion. It was a rebellion against the status quo, against the Eisenhower era that preceded it.
				</p>
				<p class="h-l">
				H.L. Sure.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Here’s the problem with the party today however, and it’s a major issue.
				<span class="break"></span>
				It’s that there is no one for these kids to rebel against, as their parents are still rebelling as well. So for many it’s like there is no Eisenhower era family to go home to; moms and dads are still finding out who they are. The parents are even hogging up the rebellion scheme.
				</p>
				<p class="h-l">
				H.L. That’s laughable and sad, but it makes complete sense to me.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well it’s not funny certainly for the Democratic Party because they are in trouble. Now when a political party falls out of favor with their demographic group they tend to become desperate and start to force the issue. They start to force what once came naturally, which is the will of the people. This is the only way to compete with the decline in demographics or sociology that would otherwise support their platform.
				<span class="break"></span>
				For example in the early 1970’s the Republican Party was guilty of this. Hence we saw Watergate. The platform and the Republican Party were going one way, the social and cultural movement the other. But the Republican Party was still locked in the past. They failed to adapt, and the consequences were disastrous.
				</p>
				<p class="h-l">
				H.L. I never saw it like that, but it is very insightful.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So you can directly parallel the Republican Party of the 1970s with the Democratic Party today. So we see what they are doing with The Theorem, they want to suppress a large discovery that they fear will further chisel away at their dated platform.
				<span class="break"></span>
				They want to control the media and the message, which let’s be honest they have done a good job at doing. But when all of that fails, the corruption will be ratcheted up to a level that will even make what you are going to see here, look mild.
				</p>
				<p class="h-l">
				H.L. They will get so desperate that they will steal the election?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I am afraid so.
				</p>
				<p class="h-l">
				H.L. That is really unfortunate. Why don’t they just change their platform to adapt?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Because that older generation is blocking the younger generation from doing so. And let’s face it, socialism doesn’t work. It may work on a local level, but not on a national one. There is no incentive and too much control by the political party. And this political party, The Democratic Party, if it even survives, is going to be under such a cloud of suspicion for the next twenty years that no one is going to want to give it that type of control.
				</p>
				<p class="h-l">
				H.L. But there seems to a demand for socialism.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Absolutely there is and that demand needs to be respected, or in this case dissected.
				</p>
				<p class="h-l">
				H.L. Hey I like that: Respect or Dissect! I think you found a great contrast. It’s a new way to modify.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, great, glad I am entertaining you.
				<span class="break"></span>
				The problem is, those building blocks of the socialist platform are an illustration of the subconscious of the electorate. Everyone is well aware that a high quality college education is way too expensive, it’s astronomical; so free college sounds good to kids.
				<span class="break"></span>
				Beneath that however lays deep frustrations of not wanting their parents to foot the bill for that education. Children are selfless giving entities, at least at birth. Part of that never leaves them; they want to make their parents happy. They don’t want to see them struggle.
				<span class="break"></span>
				Also as we have seen, some of the parents are just selfish and don’t want to struggle for their children. So they are asking their government for what they cannot ask, or are afraid to ask their family for.
				</p>
				<p class="h-l">
				H.L. Having the government take over the role of the family though, I don’t see that working out.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You’re right it’s a horrible idea, but these kids have nowhere to turn. So therefore free things sound appealing, because they feel they are entitled to get something free as they are already paying a high price at home. They are being sucked dry by their own families, and as we have seen it’s exhausting to them.
				</p>
				<p class="h-l">
				H.L. Wouldn't it be better if they just dealt with the problems at home, their parent’s selfishness?
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is true, but not easier. Definitely it would be better for them and the country in the long run.
				<span class="break"></span>
				But that is really hard to do when you are young. It’s very painful and takes years, and then you realize you can’t fix your family. It’s a mess; better to wait until at least until your late twenties to start digging into that dirt, at least really deep into it.
				</p>
				<p class="h-l">
				H.L. Then you have someone like Bernie Sanders and the others who are harnessing that parental resentment and pointing it at the government.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That is exactly what they are doing. It’s very effective, but the road leads to a dead end street.
				<span class="break"></span>
				One of the reasons colleges are so expensive is because they are quasi-socialist in nature: professors get big money, they often work little, spending much of their time publishing; every week it’s a birthday party in the office. Summers off, government money; the list goes on and on, it’s Fantasyland.
				<span class="break"></span>
				That’s great for the employees, but the student’s pay for the party in the end. Now imagine everything being as expensive as college, and you start to get the idea of the nightmare socialism would be. It’s a bad bet having the government take the place of your family like you said; you are setting yourself up for a letdown.
				<span class="break"></span>
				No, the bus that took us in here was capitalism and that needs to be the bus that takes us out. So right now the bus is temporarily broken down, we will get it repaired and be on our way.
				</p>
				<p class="h-l">
				H.L. Speaking of capitalism, do you think Donald Trump found enough of the people we were talking about, the way America used to be, and that’s why he won?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well I never thought of it exactly like that, but I think that’s correct. Add that to the debate and I think you got your answer; his recipe for success.
				<span class="break"></span>
				Even his slogan, to “Make America Great Again”, was such a wonderful contrast from what we all experienced for eight years.
				<span class="break"></span>
				He did, you’re right. He went out to places where people still understood what it means to sacrifice for your children, to build up a business to leave to your kids, to mortgage your house for their college. Donald Trump worked very hard as well, many rallies in smaller places and big cities. I think ultimately he won because he reached people in places most of us drive by and never take a second look at. No one was more surprised than the Democrats, as they were shocked that he found these people; the real America on the back roads and down the streets of a dream that was once so vibrant across this land.
				<span class="break"></span>
				In addition, they could not compete with his charisma and ambition. No way.
				<span class="break"></span>
				Also people are not dumb, they can see through things. You know every picture tells a story. When you looked at Donald Trump up there with his family, it was more about what you didn’t see.
				</p>
				<p class="h-l">
				H.L. What do you mean by that, didn’t see?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Everything was essentially flawless. His children were not beat down and reading off lines. They were attractive, coherent, well-educated and genuinely enthused about their father running for the presidency. A family is about balance, and the general feeling you received, the one conveyed was; our father has been supportive to us over the years, now it’s his turn to shine, and we are all here to support him!
				</p>
				<p class="h-l">
				H.L. Yes, I can see that. It’s the little things; the things most don’t register that win the election.
				</p>
				<p>
				<span class="douglas">Douglas:</span> That’s a good summation of it, yes. Of course, for me and for many, I also saw something else in the picture. This is what I meant by what you didn’t see.
				<span class="break"></span>
				Looking at his family, sure it’s not perfect but whose really is nowadays? What I noticed was his lack of net worth.
				</p>
				<p class="h-l">
				H.L. He’s a billionaire, what are you talking about?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I knew you would react to that one. Yes, he is a billionaire, but he is only worth a few billion, and we all could easily see how talented he is. So you compare that to some other billionaires who have less charisma and more money.
				<span class="break"></span>
				In my mind at least, I say to myself, well there is an inequity here. Okay why is that? Then you saw the answer when he rolled out his children. There is a sacrifice of time and energy for everything you do.
				</p>
				<p class="h-l">
				H.L. So correct me if I am wrong, but you’re saying he could have had more money if his kids were in worse shape?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I wouldn’t say it like that though. I could see that he had sacrificed the time and energy and focus on his children, which was time many men would have spent accumulating wealth for wealth sake.
				<span class="break"></span>
				You know children, especially grown children, can be an unpredictable variable. So when you need them, even if you’re wealthy but you didn’t treat them properly, they can easily rebel. They may not show up for the curtain call.
				</p>
				<p class="h-l">
				H.L. Every picture tells a story.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, especially under the cracks and pressure of a campaign. So they really showed up for him.
				</p>
				<p class="h-l">
				H.L. The debate. You said something about the debate.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, this is one of my favorite topics. It is the unwritten closed chapter on the Clinton Campaign.
				</p>
				<p class="h-l">
				H.L. But Hillary Clinton did well in the debates.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, she did. I believe she won all three of them. At least that was the scorecard I was keeping.
				<span class="break"></span>
				I know Donald Trump said he won a couple of them, but I didn’t see it. I think he performed better than expected. She is just such a polished orator, and she really was prepared. She was incredible and few could have really beaten her.
				</p>
				<p class="h-l">
				H.L. But?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well then came the night which I believe will end up over time being seen as one of the most famous political stunts of all time.
				</p>
				<p class="h-l">
				H.L. Really?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, I am convinced this will be seen as one of the greatest political moves ever in the history of presidential elections, and whoever was behind it can take the credit. It may have been Donald Trump; it may have been one of his advisors, I don’t know who was ultimately responsible.
				</p>
				<p class="h-l">
				H.L. I’m intrigued, which event?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well I believe it was the second debate, the one in St. Louis. It may have been the third, I can’t recall exactly. Anyways it was the debate where Trump’s Team brought in the four victims of Bill Clinton’s sexual misdeeds.
				</p>
				<p class="h-l">
				H.L. It was the second debate. He did it to rattle Hillary Clinton.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, well that is how the media’s interpreted it. But I could see there was another dynamic to this planning. I really believe a female on Trump’s Team had to be behind this. It was brilliant. I think only a female would have been intuitive enough to know how this subtle message would play with female voters.
				</p>
				<p class="h-l">
				H.L. What dynamic is that?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well it wasn’t so much about the sexual abuse allegations. I believe that everyone condemns that. Sure there was that factor, but this has been played out in the media for so long, I think by then everyone had already made up their mind about that situation.
				<span class="break"></span>
				It was something else. It was something so brilliant and risky and subtle, I think it went unnoticed to most on a conscious level, but set off alarms on a subconscious level. It was this, and again the message was primarily to women.
				<span class="break"></span>
				It had to do with Hillary Clinton herself and her competency to be president, to wake up in the middle of the night and get that horrible call; the call no president wants ever to get, to have to make a quick decision on how to handle any crisis.
				</p>
				<p class="h-l">
				H.L. I’m lost.
				</p>
				<p>
				<span class="douglas">Douglas:</span> The message was that Hillary Clinton can get by with just about everything. Her charisma, her charm and her willingness to work hard exempts her from much of the scrutiny others receive, we all know that. Fair or unfair, it’s the way it has been. But the presence of those four women spoke volumes. It said Hillary, we as women will not allow an exemption for you when it comes to the human heart, human emotions. This is one step you cannot skip.
				<span class="break"></span>
				You know many of us have been used; we talked about this earlier. And many of us have had our heart broken, it’s one of the most painful lessons in life, and it usually hits us when we are most ill-equipped to deal with it; when we are young.
				<span class="break"></span>
				Now we all know what ultimately must happen when we get our heart broken. We all know the steps that typically occur right?
				</p>
				<p class="h-l">
				H.L. Yes, all too well.
				</p>
				<p>
				<span class="douglas">Douglas:</span> We react, we cry and we get angry. We confront our partner. They tell us they will not cheat or hurt us again. We think we have fixed the problem. They cheat again; we typically compromise ourselves by staying longer than we should, because the pain is too great but eventually…
				</p>
				<p class="h-l">
				H.L. Yes, eventually we leave. We have to, as our partner is not ready. It hurts like nothing ever has before, but we have to go.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, exactly. We have to leave. It is for a myriad of reasons. One is that we have to feel that pain. We, as functioning adults, have to go to that place where none of us wants to go. We have to go where we have no one but ourselves. Then we have to look deep within ourselves and start the slow journey of self-discovery.
				</p>
				<p class="h-l">
				H.L. It is very painful.
				</p>
				<p>
				<span class="douglas">Douglas:</span> It is, but it defines who we are. It’s the little war we all fight. Some win, some lose, some never have to fight it. But most of us do.
				<span class="break"></span>
				Another obvious reason is that by enabling that person, the cheating or using partner, we are blocking their development. We are retarding their advancement. We essentially are doing them no favors, as we are exempting them from the pains in life. Pains that by the way is very healthy for our immune system to experience. Though it doesn’t feel like it at the time.
				<span class="break"></span>
				Now you can ignore all of this, all of what we know; and there are women and men out there who do this all the time. There are women who let men cheat and keep taking him back for 30 years. We see it everywhere. There are men that allow the same with their wives and girlfriends. That is fine, it’s a free world and you can do what you want. Sometimes these victims are poor and sometimes they are wealthy; they run from secretaries, to doctors to politicians; they are everywhere. You can accomplish much in your life without giving in to feel those pains, to heal. It’s your business. You can be anything in the world, but you can’t be The President of the United States.
				</p>
				<p class="h-l">
				H.L. That’s so good. It is very true. I never looked at it that way, but that message did radiate.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, she just wasn’t there yet. She just wasn’t ready yet. She was so busy in the rest of her life, so amazingly accomplished that she cut corners. We all cut corners. But those were corners not allowed to be cut, not at the highest level of office. In truth, she will never earn the emotional growth to qualify for that position.
				</p>
				<p class="h-l">
				H.L. Yet she says it was the hardest decision in her life to stay with Bill Clinton.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, she still doesn’t get it. She is still clueless or defiant in what she needs to do. She is violating the laws of Nature. She is skipping steps you cannot skip.
				<span class="break"></span>
				At the same time, it was a risky move by Trump’s Team to bring those women there.
				</p>
				<p class="h-l">
				H.L. You just explained why it wasn’t. I don’t get it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Alright, let’s just say, in an alternate universe Hillary Clinton had some really good political advisors. They see the women marching in; Bill Clintons victims, and they know they are screwed. They are intuitive advisors and they know in their heart exactly what I just told you. They also know this is the end for Clinton if she doesn’t take preemptive action. So they hatch a plan and they whisper it in Hillary’s ear. Hillary smiles and here we go:
				<span class="break"></span>
				Now when Donald Trump marches the women in Hillary just smiles, because she is certain she is going to be the next president. She takes one last look over at Bill; boy is he clueless about what is going to happen to him tonight. It will be the last time she will ever look at him again.
				<span class="break"></span>
				So when they start the debate, about halfway through, she turns to Trump and says, “Donald, when I saw you bring those four women in I was upset. I was not upset with you, but at myself. We have been friends for a while, and I thank you for the gesture. I am so tired of that cheating son-of -a-bitch husband. I have been abused for so many years now; it’s no secret, you all know it.
				<span class="break"></span>
				So, here’s what I am going to do. Tomorrow morning, I am going to march down to my lawyer’s office and let him know, I want out! He may be the ex-president, but Bill Clinton is also going to be my ex-husband. I am divorcing you, Bill get out of here! Watch out Washington, because your next president is going to be a single lady!”
				<span class="break"></span>
				Now you wouldn’t hear the rest of what she said, because the crowd is by this time in a frenzy, all hell has broken lose in the debate hall. Americans take a sigh of relief, knowing we don’t have to subconsciously fret for her safety every day.
				</p>
				<p class="h-l">
				H.L. That’s so true. The place would have gone wild. To add to the drama, she could have had him escorted out by security.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I like that; you have missed your calling. You should be a political advisor.
				<span class="break"></span>
				But you see what I am saying?  You know President Trump had been friends with the Clintons for years. When he talks about the Clinton’s relationship, it is with a sense of foreboding. I forget how he said it exactly, but it was something like he had seen bad marriages but he had never seen anything like that. Of course when he says that he is filling in the narrative, the missing pieces we don’t know. Because what we know already is bad.
				<span class="break"></span>
				No matter as that was the end of her candidacy in my opinion, and I think in many others. She just wasn’t there. You can be qualified, even over qualified, for the presidency in every way, but you have to be ready on an emotional level.
				</p>
				<p class="h-l">
				H.L. I don’t think Bill Clinton helped either?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Neither did Barack Obama really. His attacks were almost taunting towards Donald Trump. They seemed bitter, and personal. It was not something that I expected to see. Obama had always stayed above the fray for the most part and played the class act card.
				<span class="break"></span>
				But the number one rule to being a class act is to never talk about, or infer that you are a class act. Unfortunately towards Election Day, Obama broke that rule; suddenly Obama was the good kid in the front of the class whining about the bad kid in the back of class, and the class sided with the kid in the back: Donald Trump.
				<span class="break"></span>
				You know while Barack Obama was very loved by many Americans, so was Donald Trump. The truth is that most of us knew about Donald Trump way before we knew about Barack Obama. He never should have challenged that reality. Americans ultimately are sentimental in nature.
				</p>
				<p class="h-l">
				H.L. You think Obama was starting to unravel at that point?
				</p>
				<p>
				<span class="douglas">Douglas:</span> I think it was a mixing of that with arrogance.
				</p>
				<p class="h-l">
				H.L. Interesting.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Barack Obama had a unique ability to put on a public face, especially during the day. Then at night, he likely had a sinister side, the need to control variables he had no business controlling; the lives of others. I think he kept that very well hidden. It likely went all the way back to his childhood. Maybe at night was when his grandparents would converse about him, and he could almost hear them. He would have had a need to listen to them; were they deciding his fate? This very well could have been the origins of his obsession with surveillance.
				<span class="break"></span>
				It could even go back further. I mean here he is living with his mother in Indonesia and then at night his parents talk. His stepfather complains about Barack to his mother at night. “I can’t deal with this kid” or whatever. Then all of a sudden he is sent away. That is just devastating on a kid, to be sent away from his mother. To be cast out like that, no one ever recovers from that.
				<span class="break"></span>
				I know the media spins it as him getting a better education in Hawaii, but there is more to the story you can bet. The media doesn’t know how tramatic this is to a child, they just don’t. It is a type of rejection unfathomable.
				</p>
				<p class="h-l">
				H.L. Yes, there is always more to the story. Probably Obama can’t process everything that happened like you say. It’s too traumatic.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Likely everything is decided for the young Barack Obama at night. So there at his grandparents, he wants to listen as well. Who can blame a kid for that?
				<span class="break"></span>
				He is essentially bounced around by a bunch of academic groupies. Now he is in Seattle, now he is Indonesia, now Hawaii. Then he is cast out and left in Hawaii, while his mother runs off and has another child with his stepfather. His biological father pops into the picture and then out. His early childhood is pounded by bigger waves than the North Shore could ever generate. The theme of it all is lack of control. The theme is education means more than feelings. The theme is education means more than you. It is big stuff to deal with at any age.
				</p>
				<p class="h-l">
				H.L. That’s so true; they really followed college around like groupies.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So now you fit a kid like this into men’s clothing and you put him in a situation where he can gain control. He plays out his private drama, the need to know what is going on; the compulsion to always know what others think about him, the ability to anticipate the future. These would all be the progenitors to his obsession with surveillance.
				</p>
				<p class="h-l">
				H.L. So by surveillance he is able to offset some of that childhood trauma; interesting.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, much like Bill Clinton's controlling and abusing women offsets his. A lot of people do a lot of things for various and disorganized reasons, but not presidents. They are very effective in the channeling of their inner motivations; compartmentalizing their trauma and acting it out in a parallel manner to their accomplishments. They are like machines. Presidents do very little random.
				</p>
				<p class="h-l">
				H.L. I am really seeing another side to them, a mild respect.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Certainly they deserve that respect; so few with that amount of pain succeed to such heights.
				<span class="break"></span>
				Likely Barack Obama is not even aware of his initial true intentions to have become president. During the Bush Administration he probably saw something on television or on the internet in regards to surveillance and subconsciously something clicked deep inside of him. Where others would have been annoyed at the intrusion, the concept of having your life examined, Obama saw the other side to it. He realized the potential for empowerment, the ability to never be in the dark again. Then, unaware of his actions he unconsciously set his sights on The White House.
				<span class="break"></span>
				You know much that we see from the outside as chance or luck is anything but those things. It’s just ambition. Chance and luck make better newspapers stories however, this way we don’t have to view the ugliness of ambition in the successful, and in ourselves.
				</p>
				<p class="h-l">
				H.L. Well, you are right on the mark there.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I know we have spent a lot of time on his abandonment issues, but it will be important later. It will take a lot to get him to forfeit his logical mind for his emotional mind and start making the mistakes he is about to fall victim to.
				</p>
				<p class="h-l">
				H.L. It’s okay, this has answered the questions for me in regards to his motivation for all that surveillance. At first when you talked about all the surveillance he had on you I must admit I was a bit skeptical, but it seems only logical now, given his past.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure. The Theorem was a continuation of Hillary Clinton’s corruption and he had to contain it, because the Clintons had the goods on him. He had to know what I was doing at every moment; I held the key to his destruction. That’s how he saw it, then ultimately he fated it to happen. It’s tragic.
				<span class="break"></span>
				The thing is that none of what I am saying, especially about Obama should come as a surprise. He is ultimately, I believe, an honest man at heart. I know that is confusing, but I really believe he is not very good at lying, or even at committing a crime as we will see later.
				</p>
				<p class="h-l">
				H.L. Yes, but he didn’t do anything. He didn’t accomplish anything of value during his administration.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I disagree. You have to understand that all the criticism Barack Obama received in regards to not accomplishing anything during his presidency is unfounded.
				<span class="break"></span>
				It is absolutely as false of a statement as you can make; in reality, he accomplished something that is so large, so impossible and mind-boggling that its obscurity is testament to his success.
				<span class="break"></span>
				The problem is that to the average American, to all but a few of the political elite, his accomplishments are masked, hidden from view and tucked safely within the transient digital archives of power.
				</p>
				<p class="h-l">
				H.L. The suppression of The Theorem?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Just imagine, before you disrespect his accomplishments, as I know many conservatives do, as to the herculean task at hand: His agenda, essentially his mission is to suppress the largest psychological discovery; one the largest intellectual discoveries in the history of mankind. After all, we are not living in the 1920’s; we are not living in 16th Century. We are living in the digital age. He has to nullify progress, to hold back the entire will of the world for eight years. Again, all the while keeping those efforts masked. Knowing that he will be remembered as a do nothing president as a reward.
				</p>
				<p class="h-l">
				H.L. I know that part is true.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You have to understand, he didn’t have time to create a unique personalized creative agenda. Crisis began the day he stepped into The White House, and remained there throughout, until the day he left. The Theorem was already in the bookstores, it was out almost two years before he entered office. He inherited a political war; a central tenet of his party’s platform, his party’s future was at stake. At least this is how it was conveyed to him by the Clintons. It wasn’t his choice, as he was deeply indebted to the Democratic Party, as they had elevated him to the heights of power.
				<span class="break"></span>
				Now he does this, this entire operation for the loyalty of the party; this is all he will receive. If he gets caught, and as of 2014 this is a very real fear, then he is going to be remembered as a great villain of history; an oppressive censor to the likes perhaps the world has never seen.
				</p>
				<p class="h-l">
				H.L. Agreed.
				</p>
				<p>
				<span class="douglas">Douglas:</span> His opponent? I was certainly a worthy one. I am not some distant diluted relative of the man who has made the largest discovery in human psychology. No not at all, I was that man; the one who out of 100 plus billion people who have inhabited this planet who somehow, in some way decoded the very keys to the mysteries of our behavior that have puzzled our entire species since its inception.
				<span class="break"></span>
				Certainly no one expects to oppose someone who made a very powerful, world changing discovery when they enter The White House. It’s not in the manual; there are no instructions on how to do it.
				<span class="break"></span>
				No, what people, what everyone fails to realize is the fact that this man, Barack Obama fought a nearly impossible opponent, impossible odds and came out victorious. He is a champion, by every definition of the term. As much as I hate to do so, I must bow to that.
				</p>
				<p class="h-l">
				H.L. I can see what you are saying; it’s just all behind the scenes.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, now yes some of his motives were skewed, they were sick. But we are beyond that now. We are looking at the accomplishment for accomplishment’s sake. This is his single legacy.
				</p>
				<p class="h-l">
				H.L. Suddenly it makes sense why he is spying on 35 world leaders.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Now you’re getting it. Yes, of course, he had too. All the work involved is mind-numbing. You have to control the media, rewarding those who comply and punishing those who deny.
				</p>
				<p class="h-l">
				H.L. Suddenly the 400 closed door meetings in The White House with the largest search engine, Google, makes sense.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Correct as well. You have to control the digital media. This is a major part of it.
				</p>
				<p class="h-l">
				H.L. Also, the billions of dollars in various forms of aid, money and incentives to the Ivy League Schools.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, but this is only the beginning. This is just a small part, because many people are defiant by nature. Some you may have to throw in jail, some careers you may have to destroy. In fact, many careers you will have to destroy.
				<span class="break"></span>
				But it is such a large world, such a massive connected world.
				</p>
				<p class="h-l">
				H.L. And you are all over the place.
				</p>
				<p>
				<span class="douglas">Douglas:</span> I am all over the place. And he had to watch me at every single second. Not one place could I go without being shadowed, reported on and briefed about.
				<span class="break"></span>
				Do you know how vulnerable he must have felt as a man in doing that? Could you imagine, just for a minute how that affects you on a personal level? All for an agenda you inherited, one you most certainly did not want.
				</p>
				<p class="h-l">
				H.L. Yes, I could only imagine. It was stifling for him.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So yes, I can tell you about surveillance, all over the world. I can tell you about men, like I have never seen before, soldiers in his employ; soldiers in shape, his elite secret force, fit and muscular to such a degree that it twists the human brain into a pretzel; and this from a man, this man, who has spent his life in gyms all over the world.
				<span class="break"></span>
				These men of his who don’t even look like men, but instead machines as they are so perfect in every way imaginable, not an ounce of body fat separating the striated, layered muscle; human killing machines, weapons sent to rescue me in Central America or prevent me from being rescued. Only Barack Obama knows which is correct.
				<span class="break"></span>
				I could tell you about incidents, and psychological tactics that are so groundbreaking that they defy belief. But the problem is, where do I start and where do I stop? I could write 80,000 words on 8 years or more of surveillance alone.
				<span class="break"></span>
				What I am saying, is this is our unwritten history. He went to war with an idea, which is never a good option. He modified the tools he had to accomplish that war, and he brought the best of what America had to offer to the table; the best surveillance, the best soldiers, the best mind-fucking techniques. And ultimately he came out victorious, battle after battle he defeated me.
				<span class="break"></span>
				Of course, I wasn’t fighting anyone; maybe myself. And finally when I began an offensive in 2014, then things changed. Suddenly I was not asleep anymore, so the battle heated up in intensity.
				<span class="break"></span>
				Look, I am not condoning it, but I don’t want anyone not to receive credit for what they accomplished. Otherwise I will be just as bad as them.
				</p>
				<p class="h-l">
				H.L. That makes sense.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Let’s be honest, I am unpredictable and high maintenance as an enemy can be. Its micromanagement 101 taken to a new extreme; he had to ensure my safety, but at the same time make sure I did not get enough air to go to direct head to head battle with him.
				</p>
				<p class="h-l">
				H.L. Which is exactly what you did in 2014.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes. So just imagine, again. What if I told you that you could be president, but you had to spend eight years behind the scenes involuntarily obsessed with another man? Would you do it?  Would it be worth it?
				</p>
				<p class="h-l">
				H.L. Absolutely not. Sounds miserable. The first four years of your term you are stuck there with that watchdog of Hillary Clinton observing your every move, making sure you tow the party line. The line she and her husband invented. No thanks!
				</p>
				<p>
				<span class="douglas">Douglas:</span> I agree. I can’t imagine. What a waste of time; really, what a sad agenda. But he completed it. He was victorious.
				<span class="break"></span>
				What I am saying is that interest in The Theorem, in the discovery, is similar to a massive volcano. It just keeps building up pressure and when it finally erupts only then will you realize how impossible it was to keep it suppressed. Only then will you realize what in a sick, sinister and methodical way he accomplished all I am illustrating here.
				<span class="break"></span>
				In its sheer force and effectiveness, in its gargantuan size, this operation was a victory, a supreme victory for the forces of suppression. You have to understand those words or none of this will make sense.
				</p>
				<p class="h-l">
				H.L. And the work itself, The Theorem?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly. Here, you are not just fighting my strength, but the energy of the discovery itself. A discovery so simple that a 12 year old-kid could click on The Theorems’ website and know in 15 minutes this is exactly how they were developed into this world. It is so logical, so simple, laced with such common sense, and yet so dynamic at the same time. In short, it is obvious.
				</p>
				<p class="h-l">
				H.L. That’s funny, it is so true. A 12 year-old kid could figure it out.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, you have to be completely toxic, completely out of touch with yourself not to see it is correct.
				<span class="break"></span>
				At the same time, it has complexities laced within it that can fascinate the greatest minds in psychology, in neural science; complexities that still fascinate me 25 years later! I have seen the looks on the faces of the readers when they comprehend the answers and essentially begin to conquer their own origins. It is a beautiful sight.
				<span class="break"></span>
				This is what he was fighting. This is the discovery and the idea he was forced to go to war with. He had to somehow find a way, to get the world to stop believing in what they initially realized to be true instinctively. Ultimately however, this was an impossible goal. Ultimately, he could not fool everyone into fooling themselves. This is where his problems multiplied.
				</p>
				<p class="h-l">
				H.L. All of this because Hillary didn’t deal with her mother issues.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes but it’s even more isn’t it? The Clintons stole his legacy before he ever entered office. Like you said Hillary was there in the beginning. Not giving him advice or a firm hand of confidence and counsel but forcing him like a deranged mother into her wardrobe; these sick felonious outfits she made him wear, an archaic agenda so consuming that it would occupy all of his time.
				</p>
				<p class="h-l">
				H.L. That’s true; you couldn’t be in the same room as Hillary Clinton without committing a Class B Felony.
				<span class="break"></span>
				He would use any excuse to get away from The White House, to get away from her in the beginning; traveling anywhere, internationally or just to the next state.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well said. And when he was stuck in The White House, the work he had to do in regards to The Theorem must have been extremely painful.
				</p>
				<p class="h-l">
				H.L. Painful, how?
				</p>
				<p>
				<span class="douglas">Douglas:</span> He is forced to protect me, and he has. He is forced to watch me, and he did. He is forced to know every single search I accomplish, and that’s exactly what happened.
				<span class="break"></span>
				The thing is that in all of those internet searches, those hundreds of thousands of searches I never looked him up once. Do you see where this is going?
				</p>
				<p class="h-l">
				H.L. I think so. It’s the vulnerability. To be forced to deeply examine someone’s life and they are not even the slightest bit interested in yours.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly.
				</p>
				<p class="h-l">
				H.L. That is very painful.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, it is. He is fighting a very painful battle, in a war he never wanted to wage. Now who else has he done this with? Who has he devoted a great amount of time to, even writing a book about him, and has not even given a minute of thought to him?
				</p>
				<p class="h-l">
				H.L. His father, of course.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Do you see where this is going?
				</p>
				<p class="h-l">
				H.L. Yes, you never looked him up?
				</p>
				<p>
				<span class="douglas">Douglas:</span> No, how could I? He would never let me think about him, because he was always focused on my actions, thinking about what I was doing. You know how it works.
				</p>
				<p class="h-l">
				H.L. Sure, it’s the way of the world.
				</p>
				<p>
				<span class="douglas">Douglas:</span> He was just invisible to me; this is another thing that reminded him of his relationship or lack thereof with his father.
				<span class="break"></span>
				So, what do you think is going to begin to unfold when I start looking up billionaires, and businessmen; becoming fascinated with their lives?
				</p>
				<p class="h-l">
				H.L. Anger, jealousy and resentment.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Sure, and you don’t even need to have father issues to feel rejected by that.
				<span class="break"></span>
				I know if I was forced to watch some dupe for eight years, study his every move, his every search on the internet. He never looks me up, but now he is suddenly fascinated by the lives of some other men. I would feel invisible, especially if their accomplishments from a societal viewpoint were less than mine.
				</p>
				<p class="h-l">
				H.L. Sure, after all he is The President of The United States, one of the highest accomplishments in the world, and you turn your nose up to him, and become interested in stock traders and hedge fund managers. He was probably like, what do I have to do to get your attention?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well he got it.
				</p>
				<p class="h-l">
				H.L. Yes he did, when he started the prosecutions of these guys. He got it then.
				<span class="break"></span>
				But he did have father issues. So it made it worse right?
				</p>
				<p>
				<span class="douglas">Douglas:</span> He must have been miserable, I’m sure. It certainly had to be a significant aspect of the unhappiness he radiated, and tried so hard to conceal. It must have been hell, the entire battle, the complete war. To sit there and be reminded of your invisibility to men, day in and day out. I could only imagine.
				</p>
				<p class="h-l">
				H.L. But it is not so much that he is invisible to men; in that scenario as it was his job. A job he probably didn’t want to begin with.
				</p>
				<p>
				<span class="douglas">Douglas:</span> So true, good point. But it is hard to discriminate that in the middle of something. It would have been for him, for anyone. You just feel the pain, day after day.
				</p>
				<p class="h-l">
				H.L. Makes sense.
				</p>
				<p>
				<span class="douglas">Douglas:</span> To add to your observation, now it’s different right?
				</p>
				<p class="h-l">
				H.L. I don’t get it. What is different?
				</p>
				<p>
				<span class="douglas">Douglas:</span> Well now that he is not focused on me, I am free to actually think about him, and his actions. He is actually a very interesting man. I am not stifled by his intent as I used to be.
				<span class="break"></span>
				It is not his job anymore. If he checks on me now it is likely just out of habit. Like an old retired guy, driving past the company he used to work for. Just to remember, to bring it all back down into his subconscious, then up again and find a permanent home for it within his memory.
				</p>
				<p class="h-l">
				H.L. Some good memories, some bad.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Yes, habit.
				<span class="break"></span>
				I don’t know if this is making any sense to you really, it is quite complex.
				</p>
				<p class="h-l">
				H.L. No, it makes total sense. If I seem like I am drifting off, it is just I am only now starting to realize how large the scope of this operation was.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Okay, yes. It is his legacy. Suppressing The Theorem and <span class="italic">The Legacy Letter</span> is his legacy. The Obama Care; wasn’t that Clinton’s idea as well? Didn’t she float that idea years ago? I may be wrong.
				</p>
				<p class="h-l">
				H.L. No, she talked about it.
				</p>
				<p>
				<span class="douglas">Douglas:</span> You see he didn’t even have time to come up with a bad idea, more or less a good one.
				</p>
				<p class="h-l">
				H.L. That is so true. He just kept chasing the rabbit around the track.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exactly, Hillary Clinton’s rabbit.
				</p>
				<p class="h-l">
				H.L. It was complete. He essentially snuffed you out; Bill Clinton snuffing out the female spirit because of his issues with his mother; Barack Obama stifling you because he had issues with his father. The list goes on and on.
				<span class="break"></span>
				I think I will become a psychologist and move to D.C. I will be rich!
				</p>
				<p>
				<span class="douglas">Douglas:</span> No you would be poor, you would starve to death.
				</p>
				<p class="h-l">
				H.L. So true. You’re probably right.
				</p>
				<p>
				<span class="douglas">Douglas:</span> Exhausted. Done for the day?
				</p>
				<p class="h-l">
				H.L. Done. Cork this one up.
				</p>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	export default {
	}
</script>
<style scoped>
</style>